<template>
    <b-overlay :show="showoverlay" rounded="sm"><!--etds a chllan:1-->
        <div class="users-style">

            <h4 class="atlhr-dashboard-title mt-10 pb-4 mb-0">
                Challans
                <span>
                    <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a>
                    / Challans
                </span>
            </h4>
            <!--Challan Create Modal Starts-->
            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                <div>
                    <!-- alpha fix- changed title here  -->
                    <b-modal id="challan_modalnew" :title="' Create Challan'" @close="triggerChallanClose()" size="lg"
                        hide-footer>
                        <div class="ibox no-shadow border-2 gray-border reports-tab-nav">
                            <div class="clearfix mt-2 mx-auto px-0 py-2">
                                <div class="form-group row no-margin">
                                    <div class="col-md-6">
                                        <label>Fiscal Year</label>
                                        <select v-model="search.fiscal_year" class="form-control "
                                            @change="setFiscalSearch()">
                                            <option value="">
                                                Select Fiscal Year
                                            </option>
                                            <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'>
                                                {{ fyear.fiscal_year }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-6">
                                        <label>Month</label>
                                        <select v-model="search.month" class="form-control " @change="setMonthSearch()">
                                            <option value="">
                                                Select Month
                                            </option>
                                            <option value="June">
                                                June {{ year_segment2 }}
                                            </option>
                                            <option value="May">
                                                May {{ year_segment2 }}
                                            </option>
                                            <option value="April">
                                                April {{ year_segment2 }}
                                            </option>
                                            <option value="March">
                                                March {{ year_segment2 }}
                                            </option>
                                            <option value="February">
                                                February {{ year_segment2 }}
                                            </option>
                                            <option value="January">
                                                January {{ year_segment2 }}
                                            </option>
                                            <option value="December">
                                                December {{ year_segment1 }}
                                            </option>
                                            <option value="November">
                                                November {{ year_segment1 }}
                                            </option>
                                            <option value="October">
                                                October {{ year_segment1 }}
                                            </option>
                                            <option value="September">
                                                September {{ year_segment1 }}
                                            </option>
                                            <option value="August">
                                                August {{ year_segment1 }}
                                            </option>
                                            <option value="July">
                                                July {{ year_segment1 }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-card>
                            <template v-if="loader_challan == false">
                                <form v-if="search_by_id.payrun_id != ''" @submit="challanformSubmit"
                                    enctype="multipart/form-data">
                                    <div class="ibox no-shadow border-2 gray-border">
                                        <div class="clearfix mt-2 mx-auto px-0 py-2">
                                            <div class="form-group row no-margin">
                                                <label for="name" class="col-md-12 col-form-label">
                                                    Challan Name
                                                </label>
                                                <div class="col-md-12">
                                                    <input id="challan_title" type="text"
                                                        class="form-control float-left challan-name-field"
                                                        v-model="challanfdata.challan_title" name="challan_title">
                                                    <label class="float-left challan-reff-number">
                                                        {{ chalan_reference }}
                                                    </label>
                                                </div>
                                            </div>

                                            <b-form-group label="Payment Method"
                                                class="leave-attendance-legends col-12">
                                                <b-form-radio-group class="leave-attendance-btns w-100"
                                                    v-model="challanfdata.payment_type" buttons
                                                    button-variant="outline-secondary">
                                                    <b-form-radio value="1"><span>Cheque</span></b-form-radio>
                                                    <b-form-radio value="2"><span>Cash</span></b-form-radio>
                                                    <b-form-radio value="3"><span>Pay Order</span></b-form-radio>
                                                    <b-form-radio value="4"><span>BEFTN</span></b-form-radio>
                                                    <b-form-radio value="5"><span>RTGS</span></b-form-radio>
                                                    <b-form-radio value="6"><span>OTC</span></b-form-radio>
                                                    <!-- Mustafijur: 11-05-2026 -->
                                                </b-form-radio-group>

                                                <b-form-invalid-feedback :state="challanfdata.payment_type !== null && challanfdata.payment_type !== ''">
                                                    Please select a payment method.
                                                </b-form-invalid-feedback>
                                            </b-form-group>

                                            <div class="form-group row no-margin"
                                                v-if="challanfdata.payment_type != 2 && challanfdata.payment_type && challanfdata.payment_type != 6">
                                                 <!-- alpha fix- added "&& challanfdata.payment_type != 6" so this whole Bank Name / Cheque Number row is hidden for OTC -->
                                                <div class="col-md-6">
                                                    <label for="name" class="col-form-label">
                                                        Bank Name:
                                                    </label>
                                                    <!--<input id="bank_name" type="text" class="form-control" v-model="challanfdata.bank_name" name="bank_name">-->
                                                    <b-form-select id="bank_name" name="bank_name"
                                                        v-model="challanfdata.bank_name"
                                                        v-validate="{ required: false }" :options="bank_names"
                                                        :state="validateState('bank_name')"
                                                        aria-describedby="bank_name-feedback" data-vv-as="Bank Name">
                                                    </b-form-select>
                                                    <b-form-invalid-feedback id="bank_name-feedback">
                                                        {{ veeErrors.first('bank_name') }}
                                                    </b-form-invalid-feedback>
                                                </div>
                                                <div class="col-md-6">
                                                    <label for="name" class="col-form-label"
                                                        v-if="challanfdata.payment_type == 1">
                                                        Cheque Number:
                                                    </label>

                                                    <label for="name" class="col-form-label"
                                                        v-if="challanfdata.payment_type == 3">
                                                        Pay Order Number:
                                                    </label>

                                                    <label for="name" class="col-form-label"
                                                        v-if="challanfdata.payment_type == 4 || challanfdata.payment_type == 5">
                                                        Transaction Reference :
                                                    </label>

                                                    <div class="">
                                                        <input id="cheque_no" type="text" class="form-control"
                                                            v-model="challanfdata.cheque_no" name="cheque_no">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row no-margin justify-content-center"
                                                v-if="challanfdata.payment_type">
                                                <div class="col-md-6" v-if="challanfdata.payment_type != 2 && challanfdata.payment_type != 6" >
                                                      <!-- alpha fix- added "&& challanfdata.payment_type != 6" so this whole Cheque/Pay Order/Transaction Date column is hidden for OTC -->
                                                    <label for="name" class="col-form-label"
                                                        v-if="challanfdata.payment_type == 1">
                                                        Cheque Date:
                                                    </label>

                                                    <label for="name" class="col-form-label"
                                                        v-if="challanfdata.payment_type == 3">
                                                        Pay Order Date:
                                                    </label>

                                                    <label for="name" class="col-form-label"
                                                        v-if="challanfdata.payment_type == 4 || challanfdata.payment_type == 5">
                                                        Transaction Date:
                                                    </label>

                                                    <div class="" v-if="challanfdata.payment_type != 2 && challanfdata.payment_type != 6">
                                                        <!-- alpha fix- added "&& challanfdata.payment_type != 6" so this datepicker isn't rendered empty for OTC -->
                                                        <b-form-datepicker id="cheque_date" type="text"
                                                            class="form-control" v-model="challanfdata.cheque_date"
                                                            name="cheque_date">
                                                        </b-form-datepicker>
                                                    </div>
                                                </div>
                                                <div class=""
                                                    :class="{ 'col-md-6': challanfdata.payment_type !== 2 && challanfdata.payment_type !== 6, 'col-md-12': challanfdata.payment_type === 2 || challanfdata.payment_type === 6, }">
                                                    <!-- alpha fix- treat payment_type 6 (OTC) same as 2 (Cash): Submission Date now goes full width since the sibling column is hidden -->
                                                    <label for="name" class="col-form-label">
                                                        Submission Date:
                                                    </label>
                                                    <div class="">
                                                        <b-form-datepicker id="submission_date" type="text"
                                                            class="form-control" v-model="challanfdata.submission_date"
                                                            name="submission_date">
                                                        </b-form-datepicker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row" style="display: none;">
                                        <div class="col-md-4">
                                            <label>
                                                Company Code:
                                            </label>
                                            <br />
                                            <input id="company_code" type="text" class="form-control"
                                                v-model="company_code" name="company_code" disabled>
                                        </div>
                                        <div class="col-md-4">
                                            <label>
                                                Month:
                                            </label>
                                            <br />
                                            <select id="month" v-model="challanfdata.month" name="Month" required
                                                class="form-control" disabled>
                                                <option value="June">
                                                    June {{ year_segment2 }}
                                                </option>
                                                <option value="May">
                                                    May {{ year_segment2 }}
                                                </option>
                                                <option value="April">
                                                    April {{ year_segment2 }}
                                                </option>
                                                <option value="March">
                                                    March {{ year_segment2 }}
                                                </option>
                                                <option value="February">
                                                    February {{ year_segment2 }}
                                                </option>
                                                <option value="January">
                                                    January {{ year_segment2 }}
                                                </option>
                                                <option value="December">
                                                    December {{ year_segment1 }}
                                                </option>
                                                <option value="November">
                                                    November {{ year_segment1 }}
                                                </option>
                                                <option value="October">
                                                    October {{ year_segment1 }}
                                                </option>
                                                <option value="September">
                                                    September {{ year_segment1 }}
                                                </option>
                                                <option value="August">
                                                    August {{ year_segment1 }}
                                                </option>
                                                <option value="July">
                                                    July {{ year_segment1 }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-4">
                                            <label>
                                                Fiscal year:
                                            </label>
                                            <br />
                                            <input id="year" type="text" class="form-control"
                                                v-model="challanfdata.fiscal_year" required name="year"
                                                placeholder="Year" disabled>
                                        </div>
                                    </div>
                                    <div class="form-group row d-none">
                                        <label for="name" class="col-md-3 col-form-label">
                                            Payment Method:
                                        </label>
                                        <div class="col-md-6">
                                            <select id="payment_type" v-model="challanfdata.payment_type"
                                                name="payment_type" class="form-control">
                                                <option value="1">
                                                    Cheque
                                                </option>
                                                <option value="2">
                                                    Cash
                                                </option>
                                                <option value="3">
                                                    Pay Order
                                                </option>
                                                <option value="4">
                                                    BEFTN
                                                </option>
                                                <option value="5">
                                                    RTGS
                                                </option>
                                                <!-- Mustafijur: 11-05-2026 -->
                                                <option value="6">
                                                    OTC
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group row" style="display: none;">
                                        <div class="col-md-5">
                                            <label>
                                                Add Employee
                                                <br>
                                                in the Challan List
                                            </label>
                                            <br />
                                            <input type="hidden" v-model="current_employee_id">
                                            <input type="hidden" v-model="current_employee_etin">
                                            <input class="form-control" type="text" v-model="challansearch.name"
                                                placeholder="Search Employee.."
                                                @input="challanEmpSearch('tds_employee_dropdown')">
                                            <table class="list1" id="tds_employee_dropdown"
                                                style="width: 91%; border: 1px solid #CCC; border-collapse:separate; border-radius:6px; -moz-border-radius:6px; position: absolute; z-index: 9999999;"
                                                v-if="users.length > 0 && show_emp_list">
                                                <tr v-for="user in users" :key="user.employee_id"
                                                    style="border-bottom: 1px solid #CCC;">
                                                    <td style="min-width:200px" v-if="user.etin == ''">
                                                        <a style="cursor:pointer;"
                                                            @click="chooseemployee(user.name, user.employee_id, user.etin)">{{ user.name }}</a>
                                                    </td>
                                                    <td style="min-width:200px" v-if="user.etin != ''">
                                                        <a style="cursor:pointer;"
                                                            @click="chooseemployee(user.name, user.employee_id, user.etin)">{{ user.name }}-eTIN-{{ user.etin }}</a>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-md-2">
                                            <label>
                                                TDS
                                            </label>
                                            <br />
                                            <br />
                                            <input id="tds_field" type="text" class="form-control" v-model="tds_field"
                                                name="tds_field" />
                                        </div>
                                        <div class="col-md-3">
                                            <label>
                                                TDS (Remaining):
                                            </label>
                                            <br />
                                            <input id="tds_remaining" type="text" class="form-control  w-75"
                                                v-model="tds_remaining" required name="tds_remaining" disabled>
                                        </div>
                                        <div class="col-md-2">
                                            <label>
                                                &nbsp;
                                            </label>
                                            <br />
                                            <a class="btn btn-primary btn-full-width" @click="addemployee()"
                                                style="color: #FFFFFF;">+Add</a>
                                        </div>
                                    </div>
                                    <div class="form-group row mt-5">
                                        <b-form-group label="" class="leave-attendance-legends col-12">
                                            <b-form-radio-group class="leave-attendance-btns w-100"
                                                v-model="load_employees_tds" buttons button-variant="outline-secondary">
                                                <b-form-radio value="1" @change="loademployeestds()"><span>Show Employee
                                                        - TDS list</span></b-form-radio>
                                                <b-form-radio value="0" @change="triggerChallanClose()"><span>Hide
                                                        Employee - TDS list</span></b-form-radio>
                                            </b-form-radio-group>
                                        </b-form-group>
                                        <div class="col-md-12 text-left d-none">
                                            <a v-if="load_employees_tds != 1"
                                                class="btn btn-primary btn-full-width w-25"
                                                @click="loademployeestds()">Show Employee - TDS list</a>
                                            <a v-if="load_employees_tds == 1"
                                                class="btn btn-primary btn-full-width w-25"
                                                @click="triggerChallanClose()">Hide Employee - TDS list</a>
                                            <span v-if="new_challan_loading != ''">
                                                <img :src="$api_url + '/images/loading.gif'" width="30">
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="tds_loading == true">
                                        <div class="trz_loader">
                                            Fetching data ...
                                            <br />
                                            <img v-bind:src="$api_url + '/images/download-loader.svg'"
                                                class="loader-logo text-center" width="100px" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="load_employees_tds == 1">
                                            <div class="ibox no-shadow border-2 gray-border">
                                                <div class="clearfix mt-2 mx-auto px-0 py-2">
                                                    <div class="form-group row no-margin">
                                                        <div class="col-md-12 form-group">
                                                            <div class="custom-search" style="max-width: 100%;">
                                                                <input type="hidden" v-model="current_employee_id">
                                                                <input type="hidden" v-model="current_employee_etin">
                                                                <div class="input-group">
                                                                    <div class="input-group-prepend">
                                                                        <div class="input-group-text"><b-icon
                                                                                icon="search"></b-icon></div>
                                                                    </div>
                                                                    <input class="form-control" type="text"
                                                                        v-model="challansearch.name"
                                                                        placeholder="Search Employee"
                                                                        @input="challansetSearch()">
                                                                </div>
                                                            </div>
                                                            <table class="list1" id="employee_dropdown"
                                                                style="border: 1px solid #CCC; border-collapse:separate; border-radius:0.25rem; -moz-border-radius:0.25rem; position: absolute; z-index: 9999999;"
                                                                v-if="users.length > 0 && show_emp_list">
                                                                <tr v-for="user in users" :key="user.employee_id"
                                                                    style="border-bottom: 1px solid #CCC;">
                                                                    <td style="min-width:200px" v-if="user.etin == ''">
                                                                        <a style="cursor:pointer;"
                                                                            @click="chooseemployee(user.name, user.employee_id, user.etin, 0)">{{ user.name }}</a>
                                                                    </td>
                                                                    <td style="min-width:200px" v-if="user.etin != ''">
                                                                        <a style="cursor:pointer;"
                                                                            @click="chooseemployee(user.name, user.employee_id, user.etin, 0)">{{ user.name }}-eTIN-{{ user.etin }}</a>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label>
                                                                TDS (Tax Detucted at Source)
                                                            </label>
                                                            <br />
                                                            <input id="tds_field" type="text" class="form-control"
                                                                v-model="tds_field" name="tds_field"
                                                                @input="checkTdsRemaining(tds_actual, tds_field)" />
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label>
                                                                Remaining TDS
                                                            </label>
                                                            <br />
                                                            <input id="tds_remaining" type="text" class="form-control"
                                                                v-model="tds_remaining" required name="tds_remaining"
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="btn-wrapper text-center pt-5">
                                                                <a class="btn btn-primary custom-wizard-btn"
                                                                    @click="exportTDSList()"
                                                                    style="color: #FFFFFF;">Download Template</a>
                                                                <!-- Mustafijur: 11-05-2026 -->
                                                                <input type="file" ref="tdsFile"
                                                                    @change="onTdsFileChange" style="display: none" />
                                                                <!-- Mustafijur: 11-05-2026 -->
                                                                <a class="btn btn-primary custom-wizard-btn"
                                                                    @click="tdsFileInput" style="color: #FFFFFF;">Import
                                                                    to Update</a> <!-- Mustafijur: 11-05-2026 -->
                                                                <a class="btn btn-primary custom-wizard-btn"
                                                                    @click="triggerTdsAddEmployee()"
                                                                    style="color: #FFFFFF;">+ Add Employee TDS</a>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="row mb-3 d-flex flex-row justify-content-end">
                                                            <div class="col-md-3 text-end">
                                                                <a class="btn btn-primary btn-full-width" @click="exportTDSList()" style="color: #FFFFFF;">Download Template</a>
                                                            </div>
                                                            <div class="col-md-3 text-end">
                                                                <input type="file" ref="tdsFile" @change="onTdsFileChange" style="display: none" />
                                                                <a class="btn btn-primary btn-full-width" @click="tdsFileInput" style="color: #FFFFFF;">Import to Update</a>
                                                            </div>

                                                            <div class="col-md-2 text-end">
                                                                <a class="btn btn-primary btn-full-width" @click="triggerTdsAddEmployee()" style="color: #FFFFFF;">+Add</a>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ibox no-shadow border-2 gray-border">
                                                <div class="clearfix mt-2 mx-auto px-0 py-2">
                                                    <div class="row no-margin">
                                                        <div class="col-md-12">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr class="table-head">
                                                                        <td>
                                                                            Employee Name
                                                                        </td>
                                                                        <td>
                                                                            TDS (&#2547;)
                                                                        </td>
                                                                        <td>
                                                                            TDS Due(&#2547;)
                                                                        </td>
                                                                        <td>
                                                                            Actions
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(emp_tds, index) in employees_tds"
                                                                        :key="index"
                                                                        class="hover-bg table-row border-bottom mx-2">
                                                                        <td style="min-width:200px">
                                                                            {{ emp_tds['employee_name'] }}
                                                                        </td>
                                                                        <td>
                                                                            <input type="text"
                                                                                class="form-control text-right border-0"
                                                                                v-model="employees_tds_data[emp_tds['employee_id']]"
                                                                                name="emp_tds_field[]"
                                                                                @input="triggerTdsChange(emp_tds['tds'], emp_tds['employee_id'])" />
                                                                        </td>
                                                                        <td>
                                                                            <input type="text"
                                                                                class="form-control text-right border-0"
                                                                                v-model="employees_tds_remain_data[emp_tds['employee_id']]"
                                                                                name="emp_tds_field[]"
                                                                                @input="triggerTdsChange(emp_tds['tds'], emp_tds['employee_id'])" />
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <a class="btn btn-delete"
                                                                                style="cursor:pointer;"
                                                                                @click="triggerTdsRemove(index, emp_tds['employee_id'])"><b-icon
                                                                                    icon="trash-fill"></b-icon></a>
                                                                        </td>
                                                                    </tr>
                                                                    <tr class="table-row table-footer-custom">
                                                                        <td class="font-semi-bold">
                                                                            Total
                                                                        </td>
                                                                        <td class="text-right font-semi-bold">
                                                                            <template v-if="decimal_setting == 'yes'">
                                                                                {{ formatMoney(employees_tds_total.toFixed(2)) }}
                                                                            </template>
                                                                            <template v-else>
                                                                                {{ formatMoneyRound(Math.round(employees_tds_total)) }}
                                                                            </template>
                                                                        </td>
                                                                        <td class="text-right font-semi-bold">
                                                                            <template v-if="decimal_setting == 'yes'">
                                                                                {{ formatMoney(employees_tds_remaining.toFixed(2)) }}
                                                                            </template>
                                                                            <template v-else>
                                                                                {{ formatMoneyRound(Math.round(employees_tds_remaining)) }}
                                                                            </template>
                                                                        </td>
                                                                        <td></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display: none;">
                                        <br />
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label>
                                                    Payee:
                                                </label>
                                                <br />
                                                <textarea class="form-control" v-model="challanfdata.payee" rows="5"
                                                    placeholder="">
            </textarea>
                                            </div>
                                            <div class="col-md-6">
                                                <label>
                                                    Paying For:
                                                </label>
                                                <br />
                                                <textarea class="form-control" v-model="challanfdata.paying_for"
                                                    rows="5" placeholder="">
            </textarea>
                                            </div>
                                        </div>
                                        <br />
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label>
                                                    Payment Reason:
                                                </label>
                                                <br />
                                                <textarea class="form-control" v-model="challanfdata.citation" rows="5"
                                                    placeholder="">
            </textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="form-group row" style="display: none;">
                                        <div class="col-md-6" v-if="editmode == 'yes'">
                                            <label>
                                                Status
                                            </label>
                                            <select id="status" v-model="challanfdata.status" name="status"
                                                class="form-control">
                                                <option value="Pending">
                                                    Pending
                                                </option>
                                                <option value="Processing">
                                                    Processing
                                                </option>
                                                <option value="Paid">
                                                    Paid
                                                </option>
                                            </select>
                                        </div>
                                        <div v-if="challanfdata.status == 'Paid'" class="col-md-6">
                                            <label>
                                                Received Copy
                                            </label>
                                            <input type="file" class="form-control" v-on:change="onImageChange">
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-8">
                                            &nbsp;
                                        </div>
                                        <div class="col-md-12" style="text-align: center;">
                                            <span v-if="new_challan_loading != ''">
                                                <!-- <img :src="pgurl+'/public/images/loading.gif'" width="30"> -->
                                                <div class="trz_loader">
                                                    <img v-bind:src="$api_url + '/images/download-loader.svg'"
                                                        class="loader-logo text-center" width="100px" />
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="btn-wrapper text-center pt-5">
                                        <button class="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                                <div v-if="not_found_div == 'yes' && search.month != '' && search.fiscal_year != ''">
                                    <h4 class="text-center">
                                        No approved payroll run found for the selected fiscal year and month!
                                    </h4>
                                </div>
                            </template>
                            <template v-if='loader_challan == true'>
                                <div class="trz_loader">
                                    Fetching data ...
                                    <br />
                                    <img v-bind:src="$api_url + '/images/download-loader.svg'"
                                        class="loader-logo text-center" width="100px" />
                                </div>
                            </template>
                            <template v-else>
                            </template>
                        </b-card>
                    </b-modal>
                </div>
                <div>
                    <!-- alpha fix- make title dynamic  -->
                    <b-modal id="challan_modaledit" :title=challan_modal_title size="lg" hide-footer>
                        <!-- Mustafijur: 11-05-2026 -->
                        <div v-if="!challan_view_only">
                            <a class="btn btn-primary custom-wizard-btn blue mb-4" href="javascript:void(0)"
                                @click="enable_edit()"><i class="fa fa-edit mr-2" aria-hidden="true"></i>Enable
                                Editing</a>
                        </div>
                        <div class="ibox no-shadow border-2 gray-border">
                            <div class="clearfix mt-2 mx-auto px-0 py-2">
                                <div class="form-group row no-margin">
                                    <div class="col-md-6">
                                        <label>Fiscal Year</label>
                                        <input id="year" type="text" class="form-control"
                                            v-model="challanfdata.fiscal_year" required name="year" placeholder="Year"
                                            disabled>
                                    </div>
                                    <div class="col-md-6">
                                        <label>Month</label>
                                        <select id="month" v-model="challanfdata.month" name="Month" required
                                            class="form-control" disabled>
                                            <option value="January">
                                                {{ showMonthNameWithYear('January', fdata_fyear) }}
                                            </option>
                                            <option value="February">
                                                {{ showMonthNameWithYear('February', fdata_fyear) }}
                                            </option>
                                            <option value="March">
                                                {{ showMonthNameWithYear('March', fdata_fyear) }}
                                            </option>
                                            <option value="April">
                                                {{ showMonthNameWithYear('April', fdata_fyear) }}
                                            </option>
                                            <option value="May">
                                                {{ showMonthNameWithYear('May', fdata_fyear) }}
                                            </option>
                                            <option value="June">
                                                {{ showMonthNameWithYear('June', fdata_fyear) }}
                                            </option>
                                            <option value="July">
                                                {{ showMonthNameWithYear('July', fdata_fyear) }}
                                            </option>
                                            <option value="August">
                                                {{ showMonthNameWithYear('August', fdata_fyear) }}
                                            </option>
                                            <option value="September">
                                                {{ showMonthNameWithYear('September', fdata_fyear) }}
                                            </option>
                                            <option value="October">
                                                {{ showMonthNameWithYear('October', fdata_fyear) }}
                                            </option>
                                            <option value="November">
                                                {{ showMonthNameWithYear('November', fdata_fyear) }}
                                            </option>
                                            <option value="December">
                                                {{ showMonthNameWithYear('December', fdata_fyear) }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-card>
                            <form @submit="challanformSubmit" enctype="multipart/form-data">
                                <div class="ibox no-shadow border-2 gray-border">
                                    <div class="clearfix mt-2 mx-auto px-0 py-2">
                                        <div class="form-group row no-margin">
                                            <label for="name" class="col-md-12 col-form-label">
                                                Challan Name
                                            </label>
                                            <div class="col-md-12">
                                                <input id="challan_title" type="text"
                                                    class="form-control float-left challan-name-field"
                                                    v-model="challanfdata.challan_title" name="challan_title"
                                                    :disabled="editfield ? false : true">
                                                <label class="float-left challan-reff-number">
                                                    {{ challanfdata.challan_ref }}
                                                </label>
                                            </div>
                                        </div>
                                        <b-form-group label="Payment Method" class="leave-attendance-legends col-12">
                                            <b-form-radio-group class="leave-attendance-btns w-100"
                                                v-model="challanfdata.payment_type"
                                                :style="{ pointerEvents: editfield ? 'auto' : 'none' }" buttons
                                                button-variant="outline-secondary" :readonly="editfield ? false : true">
                                                <b-form-radio value="1"><span>Cheque</span></b-form-radio>
                                                <b-form-radio value="2"><span>Cash</span></b-form-radio>
                                                <b-form-radio value="3"><span>Pay Order</span></b-form-radio>
                                                <b-form-radio value="4"><span>BEFTN</span></b-form-radio>
                                                <b-form-radio value="5"><span>RTGS</span></b-form-radio>
                                                <b-form-radio value="6"><span>OTC</span></b-form-radio>
                                                <!-- Mustafijur: 11-05-2026 -->
                                            </b-form-radio-group>
                                        </b-form-group>

                                        <div class="form-group row no-margin"
                                            v-if="challanfdata.payment_type != 2 && challanfdata.payment_type && challanfdata.payment_type != 6">
                                            <div class="col-md-6">
                                                <label for="name" class="col-form-label">
                                                    Bank Name:
                                                </label>
                                                <!--<input id="bank_name" type="text" class="form-control" v-model="challanfdata.bank_name" name="bank_name">-->
                                                <b-form-select id="bank_name" name="bank_name"
                                                    v-model="challanfdata.bank_name" v-validate="{ required: false }"
                                                    :options="bank_names" :state="validateState('bank_name')"
                                                    :disabled="editfield ? false : true"
                                                    aria-describedby="bank_name-feedback" data-vv-as="Bank Name">
                                                </b-form-select>
                                                <b-form-invalid-feedback id="bank_name-feedback">
                                                    {{ veeErrors.first('bank_name') }}
                                                </b-form-invalid-feedback>
                                            </div>
                                            <div class="col-md-6">
                                                <label for="name" class="col-form-label"
                                                    v-if="challanfdata.payment_type == 1">
                                                    Cheque Number:
                                                </label>

                                                <label for="name" class="col-form-label"
                                                    v-if="challanfdata.payment_type == 3">
                                                    Pay Order Number:
                                                </label>

                                                <label for="name" class="col-form-label"
                                                    v-if="challanfdata.payment_type == 4 || challanfdata.payment_type == 5">
                                                    Transaction Reference :
                                                </label>

                                                <div class="">
                                                    <input id="cheque_no" type="text" class="form-control"
                                                        v-model="challanfdata.cheque_no" name="cheque_no"
                                                        :disabled="editfield ? false : true">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row no-margin justify-content-center"
                                            v-if="challanfdata.payment_type">
                                            <div class="col-md-6"
                                                v-if="challanfdata.payment_type != 2 && challanfdata.payment_type != 6">
                                                <label for="name" class="col-form-label"
                                                    v-if="challanfdata.payment_type == 1">
                                                    Cheque Date:
                                                </label>

                                                <label for="name" class="col-form-label"
                                                    v-if="challanfdata.payment_type == 3">
                                                    Pay Order Date:
                                                </label>

                                                <label for="name" class="col-form-label"
                                                    v-if="challanfdata.payment_type == 4 || challanfdata.payment_type == 5">
                                                    Transaction Date:
                                                </label>

                                                <div class=""
                                                    v-if="challanfdata.payment_type != 2 && challanfdata.payment_type != 6">
                                                    <b-form-datepicker id="submission_date" type="text"
                                                        class="form-control" v-model="challanfdata.submission_date"
                                                        name="submission_date"
                                                        :disabled="editfield ? false : true"></b-form-datepicker>
                                                </div>
                                            </div>
                                            <div class=""
                                                :class="{ 'col-md-6': challanfdata.payment_type !== 2, 'col-md-12': challanfdata.payment_type === 2, }">
                                                <label for="name" class="col-form-label">
                                                    Submission Date:
                                                </label>
                                                <div class="">
                                                    <b-form-datepicker id="submission_date" type="text"
                                                        class="form-control" v-model="challanfdata.submission_date"
                                                        name="submission_date" :disabled="editfield ? false : true">
                                                    </b-form-datepicker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="challan_view_only">
                                    <div class="ibox no-shadow border-2 gray-border">
                                        <div class="clearfix mt-2 mx-auto px-0 py-2">
                                            <div class="form-group row no-margin">
                                                <div class="col-md-6">
                                                    <label>
                                                        Challan Number:
                                                    </label>
                                                    <input id="challan_number" type="text" class="form-control"
                                                        v-model="challanfdata.challan_number" name="challan_number"
                                                        :disabled="editfield ? false : true" required>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>
                                                        Received Date:
                                                    </label>
                                                    <b-form-datepicker id="received_date" type="text"
                                                        class="form-control" v-model="challanfdata.received_date"
                                                        name="received_date" :disabled="editfield ? false : true"
                                                        required>
                                                    </b-form-datepicker>
                                                </div>
                                            </div>
                                            <div class="form-group row no-margin">
                                                <div class="col-md-6">
                                                    <label>
                                                        Received Bank Name:
                                                    </label>
                                                    <b-form-select id="received_bank_name" name="received_bank_name"
                                                        v-model="challanfdata.received_bank_name"
                                                        v-validate="{ required: false }" :options="bank_names"
                                                        :state="validateState('received_bank_name')"
                                                        aria-describedby="bank_name-feedback" data-vv-as="Bank Name"
                                                        :disabled="editfield ? false : true" required>
                                                    </b-form-select>
                                                    <b-form-invalid-feedback id="received_bank_name-feedback">
                                                        {{ veeErrors.first('received_bank_name') }}
                                                    </b-form-invalid-feedback>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>
                                                        Received Branch Name:
                                                    </label>
                                                    <input id="received_branch_name" type="text" class="form-control"
                                                        v-model="challanfdata.received_branch_name"
                                                        name="received_branch_name"
                                                        :disabled="editfield ? false : true" />
                                                </div>
                                            </div>
                                            <div class="form-group row no-margin mb-0">
                                                <label class="col-md-12">
                                                    Remarks:
                                                </label>
                                                <div class="col-md-8">
                                                    <b-form-textarea style="height: 129px;" id="remarks" name="remarks"
                                                        rows="3" max-rows="6" v-model="challanfdata.remarks"
                                                        v-validate="{ required: false }" :state="validateState('remarks')"
                                                        aria-describedby="remarks-feedback" data-vv-as="Remarks"
                                                        :disabled="editfield ? false : true">
                                                    </b-form-textarea>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="ibox no-shadow border-2 blue-border overflow-hidden">
                                                        <div class="clearfix service_format_overview mx-auto">
                                                            <div class="number_format_header_title font-semi-bold text-center blue-bg-title"
                                                                style="font-size: 15px;"><i
                                                                    class="fa fa-download mr-2"></i>Download
                                                            </div>
                                                            <a style="font-size: 18px;border-bottom: 1px solid #E8E8E8 !important;border-radius: 0 !important;"
                                                                class="btn btn-primary btn-transparent border-0 w-100 text-left"
                                                                href="javascript: void(0)"
                                                                @click="downloadChallanPdf(challanfdata.id)"><span
                                                                    style="font-size: 14px;"><b-icon font-scale="1"
                                                                        icon="circle" class="mr-2 blue-icon"
                                                                        style="vertical-align: -4px !important;"></b-icon></span>Challan</a>
                                                            <a v-if="challanfdata.received_copy != 'null' && challanfdata.received_copy != null"
                                                                style="font-size: 18px;"
                                                                class="btn btn-primary btn-transparent border-0 w-100 text-left"
                                                                :href="$api_url + '/challandownload/' + challanfdata.id"><span
                                                                    style="font-size: 14px;"><b-icon font-scale="1"
                                                                        icon="circle" class="mr-2 blue-icon"
                                                                        style="vertical-align: -4px !important;"></b-icon></span>Received
                                                                Copy</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row mt-5" v-if="!challan_view_only">
                                    <b-form-group label="" class="leave-attendance-legends col-12">
                                        <b-form-radio-group class="leave-attendance-btns w-100"
                                            v-model="load_employees_tds" buttons button-variant="outline-secondary"
                                            :disabled="editfield ? false : true">
                                            <b-form-radio value="1"><span>Show Employee - TDS list</span></b-form-radio>
                                            <b-form-radio value="0"><span>Hide Employee - TDS list</span></b-form-radio>
                                        </b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <div class=""
                                    v-if="editfield == 1 && challanfdata.status != 'Confirmed' && load_employees_tds == 1">
                                    <div class="ibox no-shadow border-2 gray-border">
                                        <div class="clearfix mt-2 mx-auto px-0 py-2">
                                            <div class="form-group row no-margin">
                                                <div class="col-md-12 form-group">
                                                    <div class="custom-search" style="max-width: 100%;">
                                                        <input type="hidden" v-model="current_employee_id">
                                                        <input type="hidden" v-model="current_employee_etin">
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text"><b-icon
                                                                        icon="search"></b-icon></div>
                                                            </div>
                                                            <input class="form-control" type="text"
                                                                v-model="challansearch.name"
                                                                placeholder="Search Employee"
                                                                @input="challansetSearch()">
                                                        </div>
                                                    </div>
                                                    <table class="list1" id="employee_dropdown"
                                                        style="border: 1px solid #CCC; border-collapse:separate; border-radius:0.25rem; -moz-border-radius:0.25rem; position: absolute; z-index: 9999999;"
                                                        v-if="users.length > 0 && show_emp_list">
                                                        <tr v-for="user in users" :key="user.employee_id"
                                                            style="border-bottom: 1px solid #CCC;">
                                                            <td style="min-width:200px" v-if="user.etin == ''">
                                                                <a style="cursor:pointer;"
                                                                    @click="chooseemployee(user.name, user.employee_id, user.etin)">{{ user.name }}</a>
                                                            </td>
                                                            <td style="min-width:200px" v-if="user.etin != ''">
                                                                <a style="cursor:pointer;"
                                                                    @click="chooseemployee(user.name, user.employee_id, user.etin)">{{ user.name }}-eTIN-{{ user.etin }}</a>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>
                                                        TDS (Tax Detucted at Source)
                                                    </label>
                                                    <br />
                                                    <input id="tds_field" type="text" class="form-control"
                                                        v-model="tds_field" name="tds_field"
                                                        @input="checkTdsRemaining(tds_actual, tds_field)" />
                                                </div>
                                                <div class="col-md-6">
                                                    <label>
                                                        Remaining TDS
                                                    </label>
                                                    <br />
                                                    <input id="tds_remaining" type="text" class="form-control"
                                                        v-model="tds_remaining" required name="tds_remaining" disabled>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="btn-wrapper text-center pt-5">
                                                        <a class="btn btn-primary custom-wizard-btn"
                                                            @click="exportEmployeeList()"
                                                            style="color: #FFFFFF;">Download Template</a>
                                                        <!-- Mustafijur: 12-05-2026 -->
                                                        <input type="file" ref="employeeTdsFile" @change="onEmployeeTdsFileChange"
                                                            style="display: none" /> <!-- Mustafijur: 12-05-2026 -->
                                                        <a class="btn btn-primary custom-wizard-btn"
                                                            @click="employeeTdsFileInput" style="color: #FFFFFF;">Import to
                                                            Update</a> <!-- Mustafijur: 12-05-2026 -->
                                                        <a class="btn btn-primary custom-wizard-btn"
                                                            @click="addemployee()" style="color: #FFFFFF;">+ Add
                                                            Employee TDS</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ibox no-shadow border-2 gray-border"
                                    v-if="employee_counter != '0' && load_employees_tds == 1">
                                    <div class="clearfix mt-2 mx-auto px-0 py-2">
                                        <div class="row no-margin">
                                            <div class="col-md-12">
                                                <table class="table">
                                                    <thead>
                                                        <tr class="table-head">
                                                            <td>
                                                                Employee Name
                                                            </td>
                                                            <td>
                                                                TDS (&#2547;)
                                                            </td>
                                                            <td>
                                                                TDS Due(&#2547;)
                                                            </td>
                                                            <td>
                                                                Actions
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(value, index) in employeenames" :key="index"
                                                            class="hover-bg table-row border-bottom mx-2">
                                                            <td style="min-width:200px">
                                                                {{ value }}
                                                            </td>
                                                            <td class="text-right">
                                                                <template v-if="decimal_setting == 'yes'">
                                                                    {{ formatMoney(parseFloat(employeetds[index]).toFixed(2)) }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ formatMoneyRound(Math.round(employeetds[index])) }}
                                                                </template>
                                                            </td>
                                                            <td class="text-right">
                                                                <template v-if="decimal_setting == 'yes'">
                                                                    {{ formatMoney(parseFloat(employeeremainings[index]).toFixed(2)) }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ formatMoneyRound(Math.round(employeeremainings[index])) }}
                                                                </template>
                                                            </td>
                                                            <td class="text-center">
                                                                <a class="btn btn-delete"
                                                                    v-if="editfield == 1 && challanfdata.status != 'Confirmed'"
                                                                    style="cursor:pointer;"
                                                                    @click="removeemployee(index)"><b-icon
                                                                        icon="trash-fill"></b-icon></a>
                                                            </td>
                                                        </tr>
                                                        <tr class="table-row table-footer-custom">
                                                            <td class="font-semi-bold">
                                                                TDS Total (&#2547;)
                                                            </td>
                                                            <td class="text-right font-semi-bold">
                                                                <template v-if="decimal_setting == 'yes'">
                                                                    {{ formatMoney(tds_total.toFixed(2)) }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ formatMoneyRound(Math.round(tds_total)) }}
                                                                </template>
                                                            </td>
                                                            <td class="text-right font-semi-bold">
                                                                <template v-if="decimal_setting == 'yes'">
                                                                    {{ formatMoney(tdsremaining_total.toFixed(2)) }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ formatMoneyRound(Math.round(tdsremaining_total)) }}
                                                                </template>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: none;">
                                    <br />
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label>
                                                Payee:
                                            </label>
                                            <br />
                                            <textarea class="form-control" v-model="challanfdata.payee" rows="5"
                                                placeholder="">
                            </textarea>
                                        </div>
                                        <div class="col-md-6">
                                            <label>
                                                Paying For:
                                            </label>
                                            <br />
                                            <textarea class="form-control" v-model="challanfdata.paying_for" rows="5"
                                                placeholder="">
                            </textarea>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label>
                                                Payment Reason:
                                            </label>
                                            <br />
                                            <textarea class="form-control" v-model="challanfdata.citation" rows="5"
                                                placeholder="">
                            </textarea>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="form-group row" style="display: none;">
                                    <div class="col-md-6" v-if="editmode == 'yes'">
                                        <label>
                                            Status
                                        </label>
                                        <select id="status" v-model="challanfdata.status" name="status"
                                            class="form-control" :disabled="editfield ? false : true">
                                            <option value="Draft" v-if="challanfdata.status != 'Confirmed'">
                                                Draft
                                            </option>
                                            <option value="Confirmed">
                                                Confirmed
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="challanfdata.status == 'Confirmed'" class="col-md-6">
                                        <label>
                                            Received Copy
                                        </label>
                                        <input type="file" class="form-control" v-on:change="onImageChange">
                                    </div>
                                    <div class="col-md-12">
                                        &nbsp;
                                    </div>
                                    <div class="col-md-6" v-if="challanfdata.status == 'Confirmed'">
                                        <label>
                                            Challan Number:
                                        </label>
                                        <input id="challan_number" type="text" class="form-control"
                                            v-model="challanfdata.challan_number" name="challan_number"
                                            :disabled="editfield ? false : true" required>
                                    </div>
                                    <div class="col-md-6" v-if="challanfdata.status == 'Confirmed'">
                                        <label>
                                            Received Date:
                                        </label>
                                        <b-form-datepicker id="received_date" type="text" class="form-control"
                                            v-model="challanfdata.received_date" name="received_date"
                                            :disabled="editfield ? false : true" required>
                                        </b-form-datepicker>
                                    </div>
                                </div>
                                <div class="btn-wrapper text-center pt-5">
                                     <!-- alpha fix- maked the btn update  -->
                                    <button v-if="editfield == 1" class="btn btn-primary">
                                        Update
                                    </button>
                                </div>
                            </form>
                        </b-card>
                    </b-modal>
                </div>
                <div>
                    <b-modal id="challan_modal_confirm" title="Challan Confirm" size="lg" hide-footer>
                        <b-card>
                            <form @submit="challanStatusSubmit" enctype="multipart/form-data">
                                <div class="reports-tab-nav">
                                    <div class="clearfix mt-2 mx-auto px-0 py-2">
                                        <div class="form-group row no-margin">
                                            <label for="name" class="col-md-12 col-form-label">
                                                Challan Name
                                            </label>
                                            <div class="col-md-12">
                                                <input type="text" class="form-control float-left challan-name-field"
                                                    v-model="challanfdata.challan_title" name="challan_title">
                                                <label class="float-left challan-reff-number">
                                                    {{ challanfdata.challan_ref }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="form-group row no-margin">
                                            <div class="col-md-6">
                                                <label>
                                                    Status
                                                </label>
                                                <select id="status" v-model="challanfdata.status" name="status"
                                                    class="form-control"
                                                    :disabled="confirm_action == 'confirm_locked' ? true : false">
                                                    <option value="Confirmed">
                                                        Confirmed
                                                    </option>
                                                    <option value="Draft" v-if="challanfdata.status != 'Confirmed'">
                                                        Draft
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <label>
                                                    Received Copy
                                                </label>
                                                <!-- <input type="file" class="form-control" v-on:change="onImageChange"> -->
                                                <b-form-group id="file-group">
                                                    <b-form-file @change="onImageChange"></b-form-file>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-12">
                                                &nbsp;
                                            </div>
                                            <div class="col-md-6">
                                                <label>
                                                    Challan Number:
                                                </label>
                                                <input id="challan_number" type="text" class="form-control"
                                                    v-model="challanfdata.challan_number" name="challan_number"
                                                    :disabled="confirm_action == 'confirm_locked' ? true : false"
                                                    required>
                                            </div>
                                            <div class="col-md-6">
                                                <label>
                                                    Received Date:
                                                </label>
                                                <b-form-datepicker id="received_date" type="text" class="form-control"
                                                    v-model="challanfdata.received_date" name="received_date" required>
                                                </b-form-datepicker>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group row no-margin">
                                                <div class="col-md-6">
                                                    <label>
                                                        Received Bank Name:
                                                    </label>
                                                    <b-form-select id="received_bank_name" name="received_bank_name"
                                                        v-model="challanfdata.received_bank_name"
                                                        v-validate="{ required: false }" :options="bank_names"
                                                        :state="validateState('received_bank_name')"
                                                        aria-describedby="bank_name-feedback" data-vv-as="Bank Name"
                                                        required>
                                                    </b-form-select>
                                                    <b-form-invalid-feedback id="received_bank_name-feedback">
                                                        {{ veeErrors.first('received_bank_name') }}
                                                    </b-form-invalid-feedback>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>
                                                        Received Branch Name:
                                                    </label>
                                                    <input id="received_branch_name" type="text" class="form-control"
                                                        v-model="challanfdata.received_branch_name"
                                                        name="received_branch_name" />
                                                </div>
                                            </div>
                                            <div class="form-group row no-margin">
                                                <div class="col-md-12">
                                                    <label>
                                                        Remarks:
                                                    </label>
                                                    <b-form-textarea id="remarks" name="remarks" rows="3" max-rows="6"
                                                        v-model="challanfdata.remarks" v-validate="{ required: false }"
                                                        :state="validateState('remarks')"
                                                        aria-describedby="remarks-feedback" data-vv-as="Remarks">
                                                    </b-form-textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="btn-wrapper text-center pt-5">
                                            <button class="btn btn-primary">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </b-card>
                    </b-modal>
                </div>
                <div>
                    <b-modal id="draft-modal" title="Are you sure you want to revert this Challan to draft?"
                        hide-footer>
                        Please enter your password to continue:
                        <br />
                        <input id="draftpass" type="password" class="form-control" v-model="draftpass" name="draftpass">
                        <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert"
                            style="clear: both; margin-top: 10px;">
                            {{ incorrectpass }}
                        </div>
                        <div style="height: 10px;clear:both;">
                            &nbsp;
                        </div>
                        <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                            @click="draftChallan(draft_challan_id)">Revert to Draft <span
                                v-if="draft_loading != ''"><img :src="$api_url + '/images/loading.gif'"
                                    width="20"></span></a>
                        &nbsp;&nbsp;
                        <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                            @click="$bvModal.hide('draft-modal')">Cancel</a>
                        <div style="height: 5px;clear:both;">
                            &nbsp;
                        </div>
                    </b-modal>
                </div>
                <div v-if="modalsuccess != ''" class="alert alert-success" role="alert">
                    {{ modalsuccess }}
                </div>
                <!-- <div v-if="search_by_id.payrun_id !=''"><b>All Challans: {{current_payrun_name}}</b></div>  -->
                <div class="reports-tab-nav">
                    <table class="table">
                        <tr>
                            <td style="text-align: right; padding-right:0; vertical-align:middle;">
                                <div class="row">
                                    <!-- alpha fix- maked pl-2  -->
                                    <div class="col-sm-6 pl-2"><!--etds a chllan:1 start-->
                                        <div class="align-self-center custom-search pr-0" style="max-width: 95%;">
                                            <template v-if="show_challan_list">
                                                <b-input-group>
                                                    <b-input-group-prepend is-text>
                                                        <b-icon icon="search"></b-icon>
                                                    </b-input-group-prepend>
                                                    <b-form-input type="search" placeholder="Search...."
                                                        v-model="search_bar" @input="resetPagination()"></b-form-input>
                                                </b-input-group>
                                            </template>
                                            <template v-else>
                                                <!--etds a chllan:2 Start: Rejwan: 03-03-2025-->
                                                <div class="d-flex align-items-center">
                                                    <b-button id="filter_button"
                                                        class="btn btn-secondary custom-secodary-btn mt-lg-1 mr-2 float-left"
                                                        @click="exportEmployeeForeTds()"
                                                        v-if="$acl['downloadselectedchallans'] == 2 || $acl['challanstorevue'] == 2">Export
                                                        all active employees for eTDS</b-button>
                                                    &nbsp;

                                                    <b-button id="filter_button"
                                                        class="btn btn-secondary custom-secodary-btn mt-1 mr-lg-1 float-left "
                                                        @click="exportEmployeeForeTds(1)"
                                                        v-if="$acl['downloadselectedchallans'] == 2 || $acl['challanstorevue'] == 2">Export
                                                        selected employees for eTDS</b-button>
                                                </div>



                                                <!--etds a chllan:2 End: Rejwan: 03-03-2025-->
                                            </template>
                                        </div>
                                    </div> <!--etds a chllan:1 end-->
                                    <div
                                        class="col-sm-6 cursor-pointer text-right company-form-box-title pl-0 trz_ppl_wrapper_2">
                                        <!--etds a chllan:1-->
                                        <!--etds a chllan:1 start-->
                                        <b-button id="filter_button" class="btn btn-primary mr-1"
                                            @click="showChallanList()">
                                            <!--etds a chllan:1 Rejwan: 25-02-2025-->
                                            <!-- alpha fix- make the icon left side of name  -->

                                            <b-icon class="ml-3" icon="house">
                                            </b-icon>
                                            Challans

                                        </b-button>
                                        <!-- Abdullah26 added mr-2  -->
                                        <b-button id="filter_button" class="btn btn-primary"
                                            :class="show_challan_list ? 'mr-1' : 'mr-2'" @click="geteTDSLists()">
                                              <!-- alpha fix- make the icon left side of name  -->
                                                <b-icon class="ml-3" icon="file-earmark-spreadsheet">
                                            </b-icon>
                                            eTDS

                                        </b-button>
                                        <!--etds a chllan:1 end-->
                                        <b-button v-if="show_challan_list" id="filter_button"
                                            class="employee-filter-btn custom-secodary-btn mr-1"
                                            v-b-toggle.sidebar_right><!--etds a chllan:1-->
                                             <!-- alpha fix- make the icon left side of name  -->
                                            <b-icon class="ml-3" icon="funnel-fill">
                                            </b-icon>
                                            Filter

                                        </b-button>

                                          <!-- alpha fix- added class here  -->
                                        <b-dropdown text="Download" class="trz-custom-dropdown mr-1 challan-download-dropdown"
                                            v-if="$acl['downloadselectedchallans'] == 2 && show_challan_list"><!--etds a chllan:1-->
                                            <b-dropdown-item @click="downloadchallan('pdf')">
                                                <b-icon icon="receipt" class="mr-2" scale="1">
                                                </b-icon>
                                                Challan PDF Version
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="downloadchallan('excel')">
                                                <b-icon icon="receipt" class="mr-2" scale="1">
                                                </b-icon>
                                                Challan Excel Version
                                            </b-dropdown-item>
                                        </b-dropdown>
                                        <a class="btn btn-delete px-3 py-2 mr-1 font-semi-bold"
                                            href="javascript:void(0);" @click="deletechallan(1)"
                                            v-if="$acl['deleteselectedchallans'] == 2 && show_challan_list"><b-icon
                                                icon="trash-fill" class="mr-2"></b-icon>Delete</a><!--etds a chllan:1-->

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12 text-right">
                                        <template
                                            v-if="$acl['challanstorevue'] == 2 && show_challan_list"><!--etds a chllan:1-->
                                            <template v-if="modalsuccess != ''">
                                                <a v-if="page_payrun_id != ''" class="btn btn-primary mt-3"
                                                    :href="$api_url + '/payrun-payslips/' + page_payrun_id">
                                                    < Back to Payrun ({{ page_year }}, {{ page_month }})</a>
                                                        <a class="btn btn-primary mt-3"
                                                            style="color: #FFFFFF;text-align: right;"
                                                            @click="displaychallanmodalnew(search_by_id.payrun_id)">Create
                                                            Challan</a>
                                            </template>
                                            <template v-else>
                                                <a class="btn btn-primary mt-3" v-if="page_payrun_id != ''"
                                                    :href="$api_url + '/payrun-payslips/' + page_payrun_id">
                                                    < Back to Payrun ({{ page_year }}, {{ page_month }})</a>
                                                        <a class="btn btn-primary mt-3"
                                                            style="color: #FFFFFF;text-align: right;"
                                                            @click="displaychallanmodalnew(search_by_id.payrun_id)">Create
                                                            Challan</a>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>

                    <div v-if="show_challan_list" class="employee-table-wrapper table-sticky-height">
                        <!--etds a chllan:1 Rejwan: 25-02-2025 -->
                        <template><!--etds a chllan:1--> <!--etds a chllan:1 Rejwan: 25-02-2025 -->
                            <table
                                class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table dataTable">
                                <thead>
                                    <tr class="table-head">
                                        <td class="checkbox-col">
                                            <input type="checkbox" id="parent_checkbox" @click="selectall(1);">
                                            <label></label>
                                        </td>
                                        <td style="text-align: left;">

                                            <label class="custom-label pl-5"
                                                :class="sortKey === 'challan_ref' ? (sortOrders['challan_ref'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                @click="sortBy('challan_ref')">
                                                <span>
                                                    Reference
                                                </span>
                                            </label>
                                        </td>
                                        <td style="text-align: left;">
                                            <label class="custom-label"
                                                :class="sortKey === 'challan_title' ? (sortOrders['challan_title'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                @click="sortBy('challan_title')">
                                                <span>
                                                    Challan Details
                                                </span>
                                            </label>
                                        </td>
                                        <td style="text-align: left;">
                                            <label class="custom-label">
                                                <span>
                                                    Month – Year
                                                </span>
                                            </label>
                                        </td>
                                        <td style="text-align: left;">
                                            <label class="custom-label">
                                                <span>
                                                    Fiscal Year
                                                </span>
                                            </label>
                                        </td>
                                        <td style="text-align: left;">
                                            <label class="custom-label"
                                                :class="sortKey === 'total_amount' ? (sortOrders['total_amount'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                @click="sortBy('total_amount')">
                                                <span>
                                                    Amount
                                                </span>
                                            </label>
                                        </td>
                                        <td style="text-align: left;">
                                            <label class="custom-label"
                                                :class="sortKey === 'total_amount' ? (sortOrders['status'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                @click="sortBy('status')">
                                                <span>
                                                    Status
                                                </span>
                                            </label>
                                        </td>
                                        <td style="text-align: center;">
                                            <label class="custom-label">
                                                <span>
                                                    Action
                                                </span>
                                            </label>
                                        </td>
                                        <!--<td style="text-align: center;">Delete</td>-->
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="challans.length">
                                        <tr class="table-row hover-bg" v-for="chln in paginatedData" :key="chln.id">
                                            <td class="checkbox-col">
                                                <input type='checkbox' class="justify-content-center challan_checkbox"
                                                    v-model="challanids" name='challanids[]' :value="chln.id">
                                                <label></label>
                                            </td>
                                            <td class="cursor-pointer">
                                                <!---->
                                                <label class="mb-0 custom-label pt-1 pl-5">
                                                    <span class="cursor-pointer" @click="downloadChallanPdf(chln.id)">
                                                        {{ chln.challan_ref }}
                                                    </span>
                                                </label>
                                            </td>
                                            <td class="cursor-pointer">
                                                <span class="cursor-pointer" @click="downloadChallanPdf(chln.id)">
                                                    {{ chln.challan_title.replace(chln.challan_ref + ":", "") }}
                                                </span>
                                            </td>
                                            <td class="cursor-pointer">
                                                <span class="cursor-pointer" @click="downloadChallanPdf(chln.id)">
                                                    {{ showMonthNameWithYear(chln.month, chln.fiscal_year) }}
                                                </span>
                                            </td>
                                            <td class="cursor-pointer">
                                                <span class="cursor-pointer" @click="downloadChallanPdf(chln.id)">
                                                    {{ chln.fiscal_year }}
                                                </span>
                                            </td>
                                             <!-- alpha fix- added class text-right -->
                                            <td class="cursor-pointer text-right">
                                                <span class="cursor-pointer" @click="downloadChallanPdf(chln.id)">
                                                    {{ chln.total_amount }}
                                                </span>
                                            </td>
                                            <!--<td>
                                        <div v-if="String(chln.received_copy) != 'null'">
                                        <a v-if="chln.received_copy != 'null'" class="btn btn-primary" :href="$api_url+'/challandownload/'+chln.id">Received <i class="fa fa-download" aria-hidden="true"></i></a>
                                        </div>
                                        <div v-else><a :href="$api_url+'/challans/'+chln.id+''" target="_blank">Draft</a></div>
                                        </td>-->
                                            <td class="cursor-pointer">
                                                <div v-if="chln.status == 'Confirmed'"
                                                    class="status-success status-msg">
                                                    {{ chln.status }}
                                                </div>
                                                <div v-if="chln.status == 'Draft' || chln.status == 'Pending'"
                                                    class="status-warning status-msg">
                                                    {{ chln.status }}
                                                </div>
                                            </td>
                                            <td class="text-right position-relative">
                                                <a id="actionDropdown"
                                                    class="dropdown-toggle clearfix action-dropdown-toggle"
                                                    style="font-size: 16px;" href="#" role="button"
                                                    data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"><b-icon
                                                        icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu px-1"
                                                    aria-labelledby="actionDropdown" style="width: 275px;">
                                                    <a class="btn btn-primary mr-1 mb-1 text-left"
                                                        href="javascript:void(0)"
                                                        @click="displayeditchallanmodal(chln.id, true)"><b-icon
                                                            icon="eye"></b-icon> View Challan</a>

                                                    <template v-if="$acl['challanstorevue'] == 2">
                                                        <div v-if="chln.status == 'Confirmed'">
                                                            <a class="btn btn-primary mr-1 mb-1 text-left"
                                                                href="javascript:void(0)"
                                                                @click="showDraftChallan(chln.id)"><b-icon
                                                                    icon="eye"></b-icon> Revert to Draft</a>
                                                        </div>
                                                    </template>



                                                    <div v-if="chln.status != 'Confirmed'">

                                                        <template v-if="$acl['challanstorevue'] == 2">
                                                            <a class="btn btn-primary text-left"
                                                                href="javascript:void(0)"
                                                                @click="displayeditchallanmodal(chln.id)"><b-icon
                                                                    icon="pencil-square"></b-icon>Edit</a>
                                                        </template>

                                                        <template v-if="$acl['challanstatusupdate'] == 2">
                                                            <a v-if="chln.status == 'Draft' || chln.status == 'Pending'"
                                                                class="btn btn-primary ml-1 text-left"
                                                                href="javascript:void(0)"
                                                                @click="displayconfirmchallanmodal(chln.id)"><b-icon
                                                                    icon="check2-circle"></b-icon>Confirm</a>
                                                        </template>


                                                    </div>

                                                    <!--etds a chllan:1 Start-->
                                                    <div>
                                                        <template
                                                            v-if="$acl['downloadselectedchallans'] == 2 || $acl['challanstorevue'] == 2">
                                                            <a class="btn btn-primary text-left"
                                                                href="javascript:void(0)"
                                                                @click="exportForeTDS(chln.id)"><b-icon
                                                                    icon="download"></b-icon>Export for eTDS</a>
                                                        </template>
                                                    </div>
                                                    <!--etds a chllan:1 End-->



                                                    <div style="border-top: 1px dashed rgba(0,0,0,.15);"
                                                        v-if="$acl['downloadselectedchallans'] == 2">
                                                        <a class="btn btn-primary text-left" href="javascript: void(0)"
                                                            @click="downloadChallanPdf(chln.id)"><b-icon
                                                                icon="download"></b-icon>Challan PDF Version</a>
                                                        <a class="btn btn-primary text-left" href="javascript: void(0)"
                                                            @click="downloadChallanExcel(chln.id)"><b-icon
                                                                icon="download"></b-icon>Challan Excel Version</a>
                                                        <a v-if="chln.received_copy != 'null' && challanfdata.received_copy != null"
                                                            class="btn btn-primary text-left"
                                                            :href="$api_url + '/challandownload/' + chln.id"><b-icon
                                                                icon="download"></b-icon>Download Received Copy</a>
                                                    </div>
                                                </div>
                                            </td>
                                            <!--<td><div v-if="String(chln.received_copy) != 'null'"> </div><div v-else><a class="btn btn-primary" href="javascript:void(0);" @click="deletechallan(chln.id)" ><i class="fa fa-trash" aria-hidden="true"></i></a></div></td>-->
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr v-if="!challan_loading">
                                            <td colspan="8">
                                                No challan found!
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                                <!--<tfoot>
                            <tr>
                            <td colspan="8"><span class="page-stats">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span></span>
                            <button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.prebuttonstatus" @click="setPagination(false)" > Prev </button>
                            <button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.nextbuttonstatus"   @click="setPagination(true)"> Next </button>
                            <select class="input" type="text" v-model="per_page" @change="setSearch()">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            </select></td>
                            </tr>
                            </tfoot>-->
                            </table>

                            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                                <template v-slot:default="{ hide }">
                                     <!-- alpha fix- added class here  -->
                                    <div class="px-3 py-2 filter-wrapper">
                                        <div>
                                            <div>
                                                <b-input-group class="mb-2">
                                                    <b-input-group-prepend is-text>
                                                        <b-icon icon="list">
                                                        </b-icon>
                                                    </b-input-group-prepend>
                                                    <select name="Fiscal Year" class='form-control'
                                                        v-model="this_search_fiscal">
                                                        <option value="">
                                                            Select Fiscal Year
                                                        </option>
                                                        <option v-for='fyear in payrunsfiscalyear'
                                                            :value='fyear.fiscal_year'>
                                                            {{ fyear.fiscal_year }}
                                                        </option>
                                                    </select>
                                                </b-input-group>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <b-input-group class="mb-2">
                                                    <b-input-group-prepend is-text>
                                                        <b-icon icon="list">
                                                        </b-icon>
                                                    </b-input-group-prepend>
                                                    <select name="Month" class='form-control'
                                                        v-model="this_search_month">
                                                        <option value="">
                                                            Select a Month
                                                        </option>
                                                        <option value="June">
                                                            June {{ year_segment2 }}
                                                        </option>
                                                        <option value="May">
                                                            May {{ year_segment2 }}
                                                        </option>
                                                        <option value="April">
                                                            April {{ year_segment2 }}
                                                        </option>
                                                        <option value="March">
                                                            March {{ year_segment2 }}
                                                        </option>
                                                        <option value="February">
                                                            February {{ year_segment2 }}
                                                        </option>
                                                        <option value="January">
                                                            January {{ year_segment2 }}
                                                        </option>
                                                        <option value="December">
                                                            December {{ year_segment1 }}
                                                        </option>
                                                        <option value="November">
                                                            November {{ year_segment1 }}
                                                        </option>
                                                        <option value="October">
                                                            October {{ year_segment1 }}
                                                        </option>
                                                        <option value="September">
                                                            September {{ year_segment1 }}
                                                        </option>
                                                        <option value="August">
                                                            August {{ year_segment1 }}
                                                        </option>
                                                        <option value="July">
                                                            July {{ year_segment1 }}
                                                        </option>
                                                    </select>
                                                </b-input-group>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <b-input-group class="mb-2">
                                                    <b-input-group-prepend is-text>
                                                        <b-icon icon="list">
                                                        </b-icon>
                                                    </b-input-group-prepend>
                                                    <select name="Status" class='form-control'
                                                        v-model="this_search_status">
                                                        <option value="">
                                                            Select Status
                                                        </option>
                                                        <option value="Draft">
                                                            Draft
                                                        </option>
                                                        <option value="Confirmed">
                                                            Confirmed
                                                        </option>
                                                    </select>
                                                </b-input-group>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <b-input-group class="mb-2">
                                                    <b-input-group-prepend is-text>
                                                        <b-icon icon="list">
                                                        </b-icon>
                                                    </b-input-group-prepend>
                                                    <b-form-input type="search" placeholder="Search by Reference.."
                                                        name="Reference" v-model="this_search_title">
                                                    </b-form-input>
                                                </b-input-group>
                                            </div>
                                        </div>
                                        <div class="py-2">
                                            <div class="mt-4 row ">
                                                <div class="col-md-6">
                                                     <!-- alpha fix- added class here  -->
                                                    <b-button class="btn filter_btn btn-primary btn-block not-collapsed text-center" v-b-toggle.sidebar_right
                                                        variant="primary" block title="Set Filter">
                                                        <div>
                                                            Set Filter
                                                        </div>
                                                    </b-button>
                                                </div>

                                                <div class="col-md-6">
                                                    <b-button class="filter_btn" variant="primary" block
                                                        title="Clear Filter" @click="resetFlter();">
                                                        <div>
                                                            Clear Filter
                                                        </div>
                                                    </b-button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </b-sidebar>
                        </template><!--etds a chllan:1 Start-->
                        <!--etds a chllan:1 Start: Rejwan: 25-02-2025 -->
                        <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                            <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length"
                                            :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                                </ul>
                                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                                    :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next"
                                    base-url="#" first-number last-number></b-pagination-nav>
                            </div>

                        </div>
                        <!--etds a chllan:1 End: Rejwan: 25-02-2025 -->
                        <!--etds a chllan:1 End-->
                    </div>
                    <!--etds a chllan:1 Start: Rejwan: 25-02-2025 -->
                    <div v-else class="card mt-0 border-0 no-shadow">
                        <common-list class="Challan-view-table" :employee_draft=1 :checkbox="checkbox"
                            :is_action="is_action" :key="list_key" :appended_column="appended_column"
                            :company_options="company_options" :employees="employees" :default_column="default_column"
                            :primary_key="primary_key" :all_employee="all_employee" edit_icon="yes"
                            v-on:childToParent="listReturn"></common-list>
                    </div>
                </div>
                <!--etds a chllan:1 End: Rejwan: 25-02-2025 -->
            </template>
            <template v-else>
                <lock-template></lock-template>
            </template>
        </div>
    </b-overlay><!--etds a chllan:1-->
</template>
<script>
export default {
    mounted() {
        //console.log('started..');
    },
    data() {

        let sortOrders = {};
        return {
            challans: [],
            payruns: [],
            payrunsfiscalyear: [],
            challanids: [],
            sortKey: 'challan_ref',
            sortOrders: sortOrders,
            columns: ['challan_ref', 'challan_title', 'fiscal_year', 'fiscal_year', 'total_amount', 'status'],
            //pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 }, //at_edit
            this_search: '',
            this_search_fiscal: '',
            this_search_month: '',
            this_search_status: '',
            this_search_title: '',
            search_bar: '',
            search: { company_code: '', company_name: '', citation: '', month: '', fiscal_year: '', month_form: '', fiscal_year_form: '', status: '', challan_title: '' },
            search_by_id: { payrun_id: '', payrun_id_form: '' },
            per_page: 10000000,
            length: 20,
            temp_length: 20,
            loader_challan: false,
            page_payrun_id: '',
            page_month: '',
            page_year: '',
            current_payrun_name: '',
            not_found_div: 'no',
            editfield: 0,
            modalsuccess: '',
            new_challan_loading: '',
            challan_loading: false,
            confirm_action: '',
            confirmed_lists: [],
            bank_names: [
                { value: null, text: "--Select--" },
            ],

            ////////////Challan Modal elements Start/////////
            users: [],
            errors: [], // 16 april 2025
            tdsAllEmployeesDataList: [],// 16 april 2025
            all_employees_tds: [],// 16 april 2025
            challanemployees: [],
            employeenames: [],
            employeetds: [],
            employees_tds: [],
            load_employees_tds: 0,
            employees_tds_total: 0,
            employees_tds_remaining: 0,
            employees_tds_data: [],
            employees_tds_actual_data: [],
            employees_tds_remain_data: [],
            employeeremainings: [],
            employeeetins: [],
            challansearch: { name: '' },
            challanfdata: [],
            success: '',
            company_code: '',
            company_name: '',
            company_address: '',
            tds_actual: '',
            tds_field: '',
            tds_remaining: '',
            tds_total: 0,
            tdsremaining_total: 0,
            employee_counter: 0,
            current_employee_id: '',
            current_employee_etin: '',
            challan_view_only: false,
            image: '',
            editmode: '',
            employee_delete_flag: '',
            chalan_reference: '',
            year_segment1: '',
            year_segment2: '',
            ////////////Challan Modal elements End/////////
            fdata_fyear: '',

            draftpass: '',
            incorrectpass: '',
            draft_challan_id: '',
            draft_loading: '',
            decimal_setting: '',
            tds_loading: false,
            backdoor: 0,
            /*etds a chllan:1 start*/
            people: 0,
            length_options: [],
            show_emp_list: false,
            show_challan_list: 1,
            checkbox: 1,
            is_action: 0,
            list_key: 0,
            employees: [],
            //default_column:['name','phone','email','jobposition','department','branch'],
            // alpha fix- chnaged etin to e-Tin
            default_column: ['name', 'e-Tin', 'phone', 'email', 'jobposition', 'department', 'branch'], //etds a chllan:1 Rejwan: 19-02-2025
            primary_key: 'employee_id',
            company_options: [],
            appended_column: [],
            /***Child Component property data */
            selected: [],
            showoverlay: false,
            downloading: false,
            viewmode: true,
            notice: "Looks like you have not added any employee yet.",
            departments: [],
            jobpositions: [],
            all_employee: 'yes',// etds a chllan:1 Rejwan: 25-02-2025
            /*etds a chllan:1 end*/

              // alpha fix- added this
            challan_modal_title: "View Challan",

        }
    },

    methods: {

        /*etds a chllan:1 start*/
        listReturn: function (data) {
            if (data.selected.length > 0) {
                this.selected = data.selected;
            }
            else {
                this.selected = [];
                if (data.employee_id > 0) {
                    this.editEmployee(data.employee_id, 0);
                }

            }
        },

        exportEmployeeForeTds(selected = false) {
            if (selected && !this.selected.length) { // etds a chllan:1 Rejwan: 25-02-2025
                this.$bvToast.toast("Select employee for eTDS!!!", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            } else {
                let currentObj = this;
                this.$bvToast.toast('It might take a while', { title: `Info`, variant: 'info', solid: true });
                this.showoverlay = true;
                let formData = new FormData();

                let export_url = '';

                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }

                export_url = this.$api_url + '/challan/exportetds';


                if (selected && this.selected) {
                    formData.append('employee_ids', this.selected);
                }
                axios.post(export_url, formData, config)
                    .then(function (response) {
                        currentObj.showoverlay = false; //Export-Import Investmet
                        //var fileURL = response.data;
                        //this.download_file(fileURL);
                        if (response.data.type == 'application/json') {
                            let file = new Blob([response.data], { type: 'application/json' }); /* if you use different error message just change the name instead of  'error_msg' */
                            const cast = Promise.resolve(file.text());
                            cast.then((value) => {
                                let err_obj = JSON.parse(`${value}`);
                                this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                            });
                        } else {
                            this.global_download_file_content(response);
                        }

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.errormsg = error.response.data.errors;
                        currentObj.showoverlay = false;
                    });
            }
        },
        /*etds a chllan:1 end*/

        // Added by Sohel 13-07-2022
        paginate(array, length, pageNumber) {
            let l = parseInt(array.length);
            let m = parseInt(length);
            this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';

            if (l > 0) {
                this.pagination.pages = Math.ceil(l / m);
            }
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        resetPagination() {
            this.pagination.currentPage = 1;
            this.pagination.prevPage = '';
            this.pagination.nextPage = '';
        },
        setFirstPage() {
            this.pagination.currentPage = 1;
            this.length = this.temp_length;
        },
        // Sohel code ends

        get_decimal_settings: function () {
            axios.get(this.$api_url + '/decimal-settings')

                .then(function (response) {
                    this.decimal_setting = response.data;
                }.bind(this));
        },
        showMonthNameWithYear: function (month, f_year) {
            var month_name = month + ' ';
            var month_part_1 = ['January', 'February', 'March', 'April', 'May', 'June'];
            var yr = f_year.split("-");

            if (month_part_1.indexOf(month) >= 0)
                month_name = month_name + yr[1];
            else
                month_name = month_name + yr[0];

            return month_name;
        },

        sortBy(key) {
            this.resetPagination();
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

            this.backdoor++;
        },

        formatMoney: function (amount) {
            var money = Number(amount);
            money = money.toLocaleString();
            if (money == 'NaN')
                money = amount;
            else {
                if (money.indexOf(".") < 0)
                    money = money + ".00";
            }
            return money;
        },

        formatMoneyRound: function (amount) {
            var money = parseInt(amount);
            money = money.toLocaleString();
            if (money == 'NaN')
                money = amount;
            else
                money = money
            return money;
        },

        toMoney: function (amount) {
            if (amount != "0") {
                var NumWithoutCommas = amount.replace(/,/g, '');
                var number = Number(NumWithoutCommas);
                return number;
            } else
                return 0;
        },

        resetFlter() {
            this.this_search_fiscal = '';
            this.this_search_month = '';
            this.this_search_status = '';
            this.this_search_title = '';
        },
        triggerChallanClose: function () {
            this.load_employees_tds = 0;
            this.employees_tds_total = 0;
            this.employees_tds_remaining = 0;
            this.employees_tds_data = [];
            this.employees_tds_remain_data = [];
            this.employeeremainings = [];
        },
        checkTdsRemaining: function (d_val, c_val, k_val = 'tds_remaining') {
            //alert("DValue: "+d_val+", CValue: "+c_val);
            //k_val = 9
            //this[k_val] = 9;
            var act_val = parseFloat(d_val);
            var curr_val = parseFloat(c_val);
            if (curr_val <= act_val) {
                if (d_val - c_val > 0)
                    this[k_val] = (d_val - c_val).toFixed(this.decimal_setting == 'yes' ? 2 : 0); // asfaq 28 april 2025 decimal settings
                else
                    this[k_val] = this.decimal_setting == 'yes' ? 0.00 : 0;
            } else {
                this.tds_field = act_val.toFixed(this.decimal_setting == 'yes' ? 2 : 0); // asfaq 28 april 2025 decimal settings
                this[k_val] = this.decimal_setting == 'yes' ? 0.00 : 0;
                //alert('TDS can not be greater than remaining.');
                this.$bvToast.toast("TDS can not be greater than remaining.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            }
            this.triggerTdsTotalChange();
        },

        displaychallanmodalnew: function (payrun_id) {


            /////////init for modal/////
            this.users = [],
                this.errors = []; //16 april 2025
            this.challanemployees = [],
                this.employeenames = [],
                this.employeetds = [],
                this.employeeremainings = [],
                this.employeeetins = [],
                this.challanfdata = [],

                this.modalsuccess = '',
                this.company_code = '',
                this.company_name = '',
                this.company_address = '',
                this.tds_field = '',
                this.tds_remaining = '',
                this.tds_total = 0,
                this.tdsremaining_total = 0,
                this.employee_counter = 0,
                this.current_employee_id = '',
                this.current_employee_etin = '',
                this.search.month = '';
            //this.search.fiscal_year='';
            this.search_by_id.payrun_id = '';
            this.not_found_div = 'no';
            ///////////////////////////
            this.getCompanyinfo();
            this.triggerChallanClose();
            this.editmode = "no"
            this.$bvModal.show('challan_modalnew');

        },



        displayeditchallanmodal: function (challan_id, view_only = false) {


            /////////init for modal/////
            this.users = [],
                this.errors = []; //16 april 2025
            this.challanemployees = [],
                this.employeenames = [],
                this.employeetds = [],
                this.employeeremainings = [],
                this.employeeetins = [],
                this.challanfdata = [],

                this.modalsuccess = '',
                this.company_code = '',
                this.company_name = '',
                this.company_address = '',
                this.tds_field = '',
                this.tds_remaining = '',
                this.tds_total = 0,
                this.tdsremaining_total = 0,
                this.tdsremaining_total = 0,
                this.employee_counter = 0,
                this.current_employee_id = '',
                this.current_employee_etin = '',
                this.image = '';
            this.editfield = 0;
            this.challan_view_only = view_only;

            ///////////////////////////
            //this.getCompanyinfo();
            ///console.log('test cst 1..');

            axios.get(this.$api_url + '/challaneditjson/' + challan_id, {
                params: {
                    page: 1,

                }
            }).then(function (response) {
                this.challanfdata = response.data;
                if (response.data.challan_ref)
                    this.chalan_reference = response.data.challan_ref;
                this.setemployee();
                // 15 april 2025 update edit challan list
                var eployeelist = this.challanfdata.company_employee;
                var employeearray = eployeelist.split("^^");
                var arlength = employeearray.length;
                this.tdsAllEmployeesDataList = [];
                for (let counter = 0; counter < arlength; counter++) {
                    this.tdsAllEmployeesDataList.push({
                        employee_id: this.challanemployees[counter],
                        employee_name: this.employeenames[counter],
                        tds_amount: this.employeetds[counter],
                        tds_due: this.employeeremainings[counter],
                    });
                }
                //console.log(JSON.stringify(this.tdsAllEmployeesDataList));
                // 15 april 2025 update edit challan list end
                this.editmode = "yes";
                this.fdata_fyear = this.challanfdata.fiscal_year;

            }.bind(this));


            this.$bvModal.show('challan_modaledit');
            // alpha fix- added this
               this.challan_modal_title = this.challan_view_only ? "View Challan" : "Edit Challan";

        },


        displayconfirmchallanmodal: function (challan_id, lock_action = '') {


            /////////init for modal/////
            this.users = [],
                this.errors = []; //16 april 2025
            this.challanemployees = [],
                this.employeenames = [],
                this.employeetds = [],
                this.employeeremainings = [],
                this.employeeetins = [],
                this.challanfdata = [],


                this.modalsuccess = '',
                this.company_code = '',
                this.company_name = '',
                this.company_address = '',
                this.tds_field = '',
                this.tds_remaining = '',
                this.tds_total = 0,
                this.tdsremaining_total = 0,
                this.tdsremaining_total = 0,
                this.employee_counter = 0,
                this.current_employee_id = '',
                this.current_employee_etin = '',
                this.image = '';
            this.editfield = 0;
            this.confirm_action = lock_action;

            ///////////////////////////
            //this.getCompanyinfo();

            //console.log('test cst 2..');
            axios.get(this.$api_url + '/challaneditjson/' + challan_id, {
                params: {
                    page: 1,

                }
            }).then(function (response) {
                this.challanfdata = response.data;

                if (this.challanfdata.challan_number == 'null')
                    this.challanfdata.challan_number = '';

                if (this.challanfdata.received_date == '0000-00-00')
                    this.challanfdata.received_date = '';


                this.setemployee();
                this.editmode = "yes";
                this.challanfdata.status = 'Confirmed';

            }.bind(this));


            this.$bvModal.show('challan_modal_confirm');

        },


        enable_edit: function (pageflg) {
            this.editfield = 1;

        },



        setFiscalSearch: function (pageflg) {
            var yr = this.search.fiscal_year.split("-");
            this.year_segment1 = yr[0];
            this.year_segment2 = yr[1];

            this.pagination.currentPage = 1;
            this.search_by_id.payrun_id = '';
            this.search.month = '';
            //this.getchallans();
        },

        setFieldSearch: function (pageflg) {
            this.pagination.currentPage = 1;
        },


        setpaymenttype: function (pageflg) {
            this.pagination.currentPage = 1;
            this.search_by_id.payrun_id = '';
            this.search.month = '';
            this.getchallans();
        },


        setMonthSearch: function (pageflg) {
            if (this.search.fiscal_year != '') {

                this.loader_challan = true;
                this.pagination.currentPage = 1;
                axios.get(this.$api_url + '/getpayrunid/' + this.search.month + '/' + this.search.fiscal_year, {
                    params: {
                        page: this.pagination.currentPage,
                        per_page: this.per_page,
                        search_query: '',
                        search_query_by_id: '',
                    }
                }).then(function (response) {

                    this.loader_challan = false;
                    this.search_by_id.payrun_id = response.data.payrun_id;

                    if (this.search_by_id.payrun_id == '')
                        this.not_found_div = 'yes';
                    else
                        this.not_found_div = 'no';

                    this.current_payrun_name = response.data.payrun_name;
                    this.getchallans();
                    this.getCompanyinfo();

                }.bind(this));

            }

        },




        findpayrun: function (pageflg) {

            this.pagination.currentPage = 1;
            axios.get(this.$api_url + '/getpayrunid/' + this.search.month_form + '/' + this.search.fiscal_year, {
                params: {
                    page: this.pagination.currentPage,
                    per_page: this.per_page,
                    search_query: '',
                    search_query_by_id: '',
                }
            }).then(function (response) {

                this.search_by_id.payrun_id_form = response.data.payrun_id;


            }.bind(this));

        },


        setSearch: function (pageflg) {
            this.pagination.currentPage = 1;
            this.getchallans();
        },
        setPagination: function (pageflg) {
            if (pageflg)
                this.pagination.currentPage = this.pagination.nextPage;
            else
                this.pagination.currentPage = this.pagination.prevPage;

            this.getchallans();
        },

        getpayruns: function () {

            axios.get(this.$api_url + '/list-payruns_dropdown', {
                params: {
                    page: this.pagination.currentPage,
                    per_page: this.per_page,
                    search_query: '',
                    search_query_by_id: '',
                }
            }).then(function (response) {
                this.payruns = response.data.data;


            }.bind(this));
        },

        updatelistconfirmedchallans: function (challan_lists) {
            this.confirmed_lists = [];
            if (challan_lists.length > 0) {

                for (let [key, value] of Object.entries(challan_lists)) {
                    if (!this.confirmed_lists.includes(value['id']) && value['status'] == 'Confirmed')
                        this.confirmed_lists.push(parseInt(value['id']));
                }
            }
        },

        getchallans: function () {

            this.challan_loading = true;
            axios.get(this.$api_url + '/allchallans', {
                params: {
                    page: this.pagination.currentPage,
                    per_page: this.per_page,
                }
            }).then(function (response) {
                this.challans = response.data.data;
                this.length_options = [{ value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
                ];
                this.people = response.data.total;
                this.updatelistconfirmedchallans(response.data.data);
                this.pagination.from = response.data.from;
                this.pagination.to = response.data.to;
                this.pagination.total = response.data.total;

                this.challan_loading = false;

                if (this.pagination.to == this.pagination.total) {

                    this.pagination.nextbuttonstatus = 'disabled';

                }
                else {
                    this.pagination.nextbuttonstatus = '';
                }

                if (this.pagination.from == 1) {
                    this.pagination.prebuttonstatus = 'disabled';
                }
                else {
                    this.pagination.prebuttonstatus = '';
                }


                this.columns.forEach((column) => { this.sortOrders[column] = -1; });
                if (this.pagination.currentPage < response.data.last_page)
                    this.pagination.nextPage = this.pagination.currentPage + 1;

                if (this.pagination.currentPage == 1)
                    this.pagination.prevPage = 1;
                else
                    this.pagination.prevPage = this.pagination.currentPage - 1;



                //this.sortBy('challan_ref');
            }.bind(this));
        },

        seturlSearch: function () {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            var get_year = String(urlParams.get('fiscal_year'));
            var get_month = String(urlParams.get('month'));
            var get_payrun = String(urlParams.get('payrun_id'));

            if (get_year == "" || get_year == 'null')
                this.search.fiscal_year = "";
            else {
                this.search.fiscal_year = get_year;
                this.page_year = get_year;
            }

            if (get_month == "" || get_month == 'null')
                this.search.month = "";
            else {
                this.search.month = get_month;
                this.page_month = get_month;
            }


            if (get_payrun == "" || get_payrun == 'null')
                this.search_by_id.payrun_id = "";
            else {
                this.search_by_id.payrun_id = get_payrun;
                this.setMonthSearch();
                this.page_payrun_id = get_payrun;
            }

        },


        getpayrunsfiscalyear: function () {

            axios.get(this.$api_url + '/list-payruns-fiscalyear/0', {
                params: {
                    page: this.pagination.currentPage,
                    per_page: 100,
                    search_query: '',
                    search_query_by_id: '',
                }
            }).then(function (response) {
                this.payrunsfiscalyear = response.data.data;
            }.bind(this));
        },


        deletechallans: function () {



            let currentObj = this;

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }


            let formData = new FormData();

            formData.append('challanids', this.challanids);


            axios.post(this.$api_url + '/deleteselectedchallans', formData, config)

                .then(function (response) {

                    var parent_check = document.getElementById("parent_checkbox");
                    if (parent_check.checked == true)
                        document.getElementById("parent_checkbox").click();

                    currentObj.getchallans();
                    //this.getchallans();


                })

                .catch(function (error) {

                    currentObj.output = error;

                });


            /*axios.get(this.$api_url+'/deletechallan/'+challan_id , {
                params: {
                    page: this.pagination.currentPage,
                    per_page: 100,
                    search_query: '',
                    search_query_by_id: '',
                }
        }).then(function(response){
        this.getchallans();
    }.bind(this));*/

        },


        deletechallan: function (challan_id) {
            //alert(JSON.stringify(this.confirmed_lists));

            var confirm_selected = false;
            if (this.challanids.length > 0) {

                for (let [key, value] of Object.entries(this.challanids)) {
                    //alert(value);
                    if (this.confirmed_lists.includes(parseInt(value))) {
                        confirm_selected = true;
                        break;
                    }
                }
                if (confirm_selected) {
                    this.$bvToast.toast("You have selected one or more confirmed challan to delete. You are not allowed to delete any confirmed challan.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                    return 1;
                } else {
                    this.$bvModal.msgBoxConfirm('Are you Sure to Delete the Selected Challans?', { title: 'Confirm delete', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false, centered: true }).then(value => {
                        if (value) {
                            this.deletechallans();
                        }
                    })
                        .catch(err => {
                            // An error occurred
                        });
                }
            } else {
                this.$bvToast.toast("Select challan(s) for delete.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            }
        },

        downloadchallans: function (type) {
            let currentObj = this;

            /*const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }*/

            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }


            let formData = new FormData();

            formData.append('challanids', this.challanids);
            formData.append('challantype', type);
            //console.log(this.challanids);

            axios.post(this.$api_url + '/downloadselectedchallans', formData, config)

                .then(function (response) {

                    if (response.data.type == 'application/json') {
                        let file = new Blob([response.data], { type: 'application/json' }); /* if you use different error message just change the name instead of  'error_msg' */
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            currentObj.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                        });
                    } else {
                        currentObj.global_download_file_content(response);
                    }

                })
                .catch(function (error) {

                    currentObj.output = error;

                });

        },

        getBankList: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/banklist', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.bank_names = response.data;
            }.bind(this)).catch(function (error) { this.serverError(error); });

        },

        downloadchallan: function (type) {


            //alert(this.challanids.length>0);
            if (this.challanids.length > 0) {

                this.$bvModal.msgBoxConfirm('Are you sure to download the selected challans?', { title: 'Confirm download', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false, centered: true })
                    .then(value => {
                        if (value) {
                            this.downloadchallans(type);
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    });

            } else {
                this.$bvToast.toast("Select challan(s) for download.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            }
        },
        download_file(fileURL, fileName) {
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
                save.download = fileName || filename;
                if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                } else {
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }
            else if (!!window.ActiveXObject && document.execCommand) {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        },

        /*etds a chllan:1 Start*/
        exportForeTDS: function (chln_id) {

            let currentObj = this;

            let formData = new FormData();

            let export_url = '';

            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }

            export_url = this.$api_url + '/challan/exportchallanetds';


            formData.append('challan_id', chln_id);

            currentObj.showoverlay = true;

            axios.post(export_url, formData, config)
                .then(function (response) {
                    currentObj.showoverlay = false; //Export-Import Investmet
                    //var fileURL = response.data;
                    //this.download_file(fileURL);
                    if (response.data.type == 'application/json') {
                        let file = new Blob([response.data], { type: 'application/json' }); /* if you use different error message just change the name instead of  'error_msg' */
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                        });
                    } else {
                        this.global_download_file_content(response);
                    }

                }.bind(this))
                .catch(function (error) {
                    currentObj.errormsg = error.response.data.errors;
                    currentObj.showoverlay = false;
                });

        },
        getDepartments: function () {
            axios.get(this.$api_url + '/department/list')
                .then(function (response) {
                    this.departments = [{ value: 0, text: "Select..." }].concat(response.data);
                }.bind(this));
        },
        getJobpositions: function () {
            axios.get(this.$api_url + '/jobposition/list')
                .then(function (response) {
                    this.jobpositions = [{ value: 0, text: "Select..." }].concat(response.data);
                }.bind(this));
        },
        /*etds a chllan:1 End*/

        downloadChallanPdf: function (chln_id) {

            let currentObj = this;

            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }

            axios.get(this.$api_url + '/challanpdf/' + chln_id, config).then(function (response) {
                //alert(response.data.type);
                if (response.data.type == 'application/json') {
                    let file = new Blob([response.data], { type: 'application/json' }); /* if you use different error message just change the name instead of  'error_msg' */
                    const cast = Promise.resolve(file.text());
                    cast.then((value) => {
                        let err_obj = JSON.parse(`${value}`);
                        currentObj.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                    });
                } else {
                    currentObj.global_download_file_content(response);
                }
            })
                .catch(function (error) {
                    currentObj.output = error;
                });

        },

        downloadChallanExcel: function (chln_id) {

            let currentObj = this;

            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }

            axios.get(this.$api_url + '/challanexcel/' + chln_id, config).then(function (response) {
                if (response.data.type == 'application/json') {
                    let file = new Blob([response.data], { type: 'application/json' }); /* if you use different error message just change the name instead of  'error_msg' */
                    const cast = Promise.resolve(file.text());
                    cast.then((value) => {
                        let err_obj = JSON.parse(`${value}`);
                        currentObj.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                    });
                } else {
                    currentObj.global_download_file_content(response);
                }
            })
                .catch(function (error) {
                    currentObj.output = error;
                });

        },






        ////////////Challan Modal Method Starts////////////


        triggerTdsAddEmployee: function (index) {
            if (this.current_employee_id == "") {
                this.$bvToast.toast("Please select an employee.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            } else if (this.current_employee_id != "" && this.challansearch.name != "" && this.tds_field != "") {

                var remaining = Number(this.tds_field);
                if (remaining <= 0) {
                    this.$bvToast.toast("This employee has no remaining tds value.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                } else {

                    let filtered_tds = [];
                    for (let [key, value] of Object.entries(this.employees_tds_data)) {
                        if (this.toMoney(value) > 0)
                            filtered_tds[key] = value;
                    }
                    this.employees_tds_data = filtered_tds;

                    if (this.employees_tds_data.hasOwnProperty(this.current_employee_id)) {
                        this.$bvToast.toast("This employee already exists in TDS list if you want to update please remove it first.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                    } else {
                        var tds_data = [];
                        tds_data['employee_id'] = this.current_employee_id;
                        tds_data['tds'] = this.tds_field;
                        tds_data['employee_name'] = this.challansearch.name;

                        this.employees_tds.push(tds_data);
                        this.employees_tds_data[this.current_employee_id] = this.decimal_setting == 'yes' ? this.formatMoney(this.tds_field) : this.formatMoneyRound(this.tds_field);
                        this.employees_tds_remain_data[this.current_employee_id] = this.decimal_setting == 'yes' ? this.formatMoney(this.tds_remaining) : this.formatMoneyRound(this.tds_remaining);
                        this.employees_tds_actual_data[this.current_employee_id] = this.decimal_setting == 'yes' ? this.formatMoney(this.toMoney(this.tds_actual)) : this.formatMoneyRound(this.toMoney(this.tds_actual));

                        this.employees_tds_total = this.employees_tds_total + Number(this.tds_field);
                        this.employees_tds_remaining = this.employees_tds_remaining + Number(this.tds_remaining);


                        this.challansearch.name = "";
                        this.current_employee_id = "";
                        this.tds_field = "";
                        this.tds_remaining = "";
                        this.current_employee_etin = "";
                        this.users = [];

                    }
                }

                this.triggerTdsTotalChange();

            }

        },


        triggerTdsRemove: function (index, emp_index) {

            this.employees_tds.splice(index, 1);

            this.employees_tds_data[emp_index] = 0;
            this.employees_tds_remain_data[emp_index] = 0;

            this.triggerTdsTotalChange();

        },

        sanitizeTdsInput: function (input) {
            let cleaned = input.replace(/[^0-9.,]/g, '');
            let parts = cleaned.split('.');
            if (parts.length > 2) {
                cleaned = parts.slice(0, -1).join('') + '.' + parts.slice(-1);
            }
            let number = cleaned.replace(/,/g, '');
            let floatVal = parseFloat(number);
            if (isNaN(floatVal)) return '';
            return floatVal.toLocaleString();
        },

        triggerTdsChange: function (d_val, emp_index) {

            if (!(/^[0-9.,]*$/.test(this.employees_tds_data[emp_index]))) {
                console.log('Trimming ==>' + this.employees_tds_data[emp_index])
                this.employees_tds_data[emp_index] = this.sanitizeTdsInput(this.employees_tds_data[emp_index]);
            }

            d_val = parseFloat(d_val.toString().replaceAll(',', ''));

            var c_val = this.toMoney(this.employees_tds_data[emp_index]);
            var actual_val = this.toMoney(this.employees_tds_actual_data[emp_index]);
            if (c_val > actual_val) {
                this.$bvToast.toast("TDS can not be greater than remaining.", {
                    title: 'Error!',
                    variant: 'danger',
                    solid: true
                });

                this.employees_tds_data[emp_index] = this.decimal_setting == 'yes'
                    ? this.formatMoney(actual_val)
                    : this.formatMoneyRound(actual_val);
                this.employees_tds_remain_data[emp_index] = this.decimal_setting == 'yes' ? 0.00 : 0;
            } else {
                if (d_val - c_val > 0) {
                    this.employees_tds_remain_data[emp_index] = this.decimal_setting == 'yes'
                        ? this.formatMoney(actual_val - c_val)
                        : this.formatMoneyRound(actual_val - c_val);
                } else {
                    this.employees_tds_remain_data[emp_index] = this.decimal_setting == 'yes' ? 0.00 : 0;
                }
            }

            this.triggerTdsTotalChange();
        },

        triggerTdsTotalChange: function () {

            this.employees_tds_total = 0;
            this.employees_tds_remaining = 0;

            for (let [key, value] of Object.entries(this.employees_tds_data)) {
                this.employees_tds_total = this.employees_tds_total + this.toMoney(value);
            }

            for (let [key, value] of Object.entries(this.employees_tds_remain_data)) {
                this.employees_tds_remaining = this.employees_tds_remaining + this.toMoney(value);
            }
        },


        loademployeestds: function () {
            this.employees_tds = [];
            this.load_employees_tds = 0;
            this.employees_tds_total = 0;
            this.employees_tds_remaining = 0;
            this.tds_loading = true;
            if (this.search.fiscal_year && this.search.month) {
                axios.get(this.$api_url + '/challanemployees', {
                    params: {
                        fiscal_year: this.search.fiscal_year,
                        month: this.search.month
                    }
                }).then(function (response) {

                    this.tds_loading = false;
                    //alert("This employee already added.")
                    if (response.data.data) {
                        this.employees_tds = response.data.data;
                        this.load_employees_tds = 1;
                        if (this.employees_tds.length > 0) {
                            for (var i = 0; i < this.employees_tds.length; ++i) {
                                this.employees_tds_total = this.employees_tds_total + parseFloat(this.employees_tds[i]['tds']);

                                if (this.decimal_setting == 'yes') {
                                    this.employees_tds_data[this.employees_tds[i]['employee_id']] = this.formatMoney(parseFloat(this.employees_tds[i]['tds']).toFixed(2));
                                    if (this.employees_tds_data[this.employees_tds[i]['employee_id']].indexOf(".") < 0)
                                        this.employees_tds_data[this.employees_tds[i]['employee_id']] = this.employees_tds_data[this.employees_tds[i]['employee_id']] + '.00';
                                } else {
                                    this.employees_tds_data[this.employees_tds[i]['employee_id']] = this.formatMoneyRound(Math.round(this.employees_tds[i]['tds']));
                                }
                                //this.employees_tds_data[this.employees_tds[i]['employee_id']] = this.employees_tds[i]['tds'];
                                if (this.decimal_setting == 'yes')
                                    this.employees_tds_remain_data[this.employees_tds[i]['employee_id']] = 0 + '.00';
                                else
                                    this.employees_tds_remain_data[this.employees_tds[i]['employee_id']] = 0;
                                this.employees_tds_actual_data[this.employees_tds[i]['employee_id']] = this.employees_tds[i]['tds']

                            }

                            this.employees_tds_remaining = 0;

                            // 13 april 2025
                            // Reseve all employees data
                            this.all_employees_tds = [];
                            for (const emp of this.employees_tds) {
                                this.all_employees_tds.push({
                                    employee_id: emp.employee_id,
                                    employee_name: emp.employee_name,
                                    tds_amount: this.employees_tds_data[emp.employee_id],
                                    tds_due: this.employees_tds_remain_data[emp.employee_id],
                                });
                            }
                        }

                    }

                }.bind(this));
            }

        },


        chooseemployee: function (name, id, etin, validate_exists = 1) {
            axios.get(this.$api_url + '/gettds/' + id, {
                params: {
                    page: '',
                    per_page: '',
                    search_query: '',
                    search_query_by_id: '',
                }
            }).then(function (response) {

                //default_tds = response.data.tds;
                //default_remaining=response.data.remains;


                if (this.editmode == "yes") {
                    if (this.employeenames.indexOf(name) == -1) {
                        this.challansearch.name = name;
                        this.current_employee_id = id;
                        this.current_employee_etin = etin;
                        //this.tds_field=default_tds;
                        this.tds_field = parseFloat(response.data.tds).toFixed(this.decimal_setting == 'yes' ? 2 : 0); // 22 april 2025 asfaq // asfaq 28 april 2025 decimal settings
                        this.tds_actual = parseFloat(response.data.tds).toFixed(this.decimal_setting == 'yes' ? 2 : 0); // asfaq 28 april 2025 decimal settings
                        this.tds_remaining = this.decimal_setting == 'yes' ? 0.00 : 0;
                        this.users = [];
                        this.show_emp_list = false;
                    }
                    else {
                        if (validate_exists)
                            this.$bvToast.toast("This employee already added.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                    }
                } else {
                    if (this.challanemployees.indexOf(id) == -1) {
                        this.challansearch.name = name;
                        this.current_employee_id = id;
                        this.current_employee_etin = etin;
                        //this.tds_field=default_tds;
                        this.tds_field = parseFloat(response.data.remains).toFixed(this.decimal_setting == 'yes' ? 2 : 0); // 22 april 2025 asfaq // asfaq 28 april 2025 decimal settings
                        this.tds_actual = parseFloat(response.data.remains).toFixed(this.decimal_setting == 'yes' ? 2 : 0); // asfaq 28 april 2025 decimal settings
                        this.tds_remaining = this.decimal_setting == 'yes' ? 0.00 : 0;
                        this.users = [];
                        this.show_emp_list = false;
                    }
                    else {
                        if (validate_exists)
                            this.$bvToast.toast("This employee already added.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                    }
                }
            }.bind(this));


        },


        addemployee: function (index) {
            var tds_validity = "No";
            var tds = Number(this.tds_field);
            var remaining = Number(this.tds_remaining);
            tds_validity = "Yes";


            if (tds <= 0) {
                this.$bvToast.toast("This employee has no remaining tds value.", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                return false;
            }



            /*if(tds<=remaining)
            tds_validity="Yes";
            else
            {
              alert("TDS can not be greater than remaining.");
            }*/



            if (this.current_employee_id != "" && this.challansearch.name != "" && this.tds_field != "" && tds_validity == "Yes") {
                this.challanemployees.push(this.current_employee_id);
                this.employeenames.push(this.challansearch.name);
                this.employeetds.push(this.tds_field);

                var curtds = parseFloat(this.tds_field);
                var curremainings = parseFloat(this.tds_remaining);
                var resultant_remainings = curremainings;
                if (resultant_remainings < 0)
                    resultant_remainings = 0;
                this.employeeremainings.push(resultant_remainings.toFixed(2));

                this.employeeetins.push(this.current_employee_etin);
                this.updatestack();

                this.challansearch.name = "";
                this.current_employee_id = "";
                this.tds_field = "";
                this.tds_remaining = "";
                this.current_employee_etin = "";
                this.users = [];
            }

        },



        selectall: function (index) {
            var parent_check = document.getElementById("parent_checkbox");
            this.challanids = [];

            if (parent_check.checked == true) {

                var clist = document.getElementsByClassName("challan_checkbox");
                for (var i = 0; i < clist.length; ++i) {
                    clist[i].checked = "checked";
                    //this.challanids
                    this.challanids.push(clist[i].value);
                }
            }
            else {
                var clist = document.getElementsByClassName("challan_checkbox");
                for (var i = 0; i < clist.length; ++i) { clist[i].checked = ""; }
            }

        },


        removeemployee: function (index) {


            this.employee_delete_flag = 'yes';

            this.challanemployees.splice(index, 1);
            this.employeenames.splice(index, 1);
            this.employeetds.splice(index, 1);
            this.employeeremainings.splice(index, 1);
            this.employeeetins.splice(index, 1);

            this.updatestack();
            //   15 april 2025 disabling db update on remove from the frontend. only work in submit button clicking
            //   this.challanformSubmit(event);

        },


        updatestack: function () {

            //alert(this.challanemployees.length);
            var arlength = this.challanemployees.length;
            var counter = 0;
            var stacktxt = "";
            var endofstack = arlength - 1;
            this.tds_total = 0;
            this.tdsremaining_total = 0,
                this.employee_counter = 0;
            for (counter = 0; counter < arlength; counter++) {

                if (counter == endofstack)
                    stacktxt = stacktxt + this.challanemployees[counter] + "=" + this.employeetds[counter] + "=" + this.employeeremainings[counter];
                else
                    stacktxt = stacktxt + this.challanemployees[counter] + "=" + this.employeetds[counter] + "=" + this.employeeremainings[counter] + "^^";

                this.tds_total = this.tds_total + Number(this.employeetds[counter]);
                this.tdsremaining_total = this.tdsremaining_total + Number(this.employeeremainings[counter]);
                this.employee_counter = this.employee_counter + 1;

            }

            this.challanfdata.company_employee = stacktxt;
            this.challanfdata.total_amount = this.tds_total;
            if (this.challanfdata.payment_type == 1)
                this.challanfdata.money_details = "Cheque No. -" + this.challanfdata.cheque_no + "<br> Dated " + this.challanfdata.cheque_date;
            if (this.challanfdata.payment_type == 3)
                this.challanfdata.money_details = "Pay Order No. -" + this.challanfdata.cheque_no + "<br> Dated " + this.challanfdata.cheque_date;
            else
                this.challanfdata.money_details = " &nbsp;&nbsp;&nbsp;&nbsp; Cash";



        },

        challansetSearch: function (pageflg) {
            this.challangetEmployees();

        },

        challanEmpSearch: function (index_name) {
            this.challangetEmployees(index_name);

        },


        challangetEmployees: function (index_name = 'employee_dropdown') {
            // etds a chllan:2 Start Rejwan: 03-03-2025
            if (this.challansearch.name != "") {
                //document.getElementById(index_name).style.display="block";
                this.show_emp_list = true;
            }
            else {
                //document.getElementById(index_name).style.display="none";
                this.show_emp_list = false;
            }
            // etds a chllan:2 End Rejwan: 03-03-2025

            axios.get(this.$api_url + '/allemployees', {
                params: {
                    page: 1,
                    per_page: 15,
                    search_query: this.challansearch,
                    search_query_by_id: '',
                }
            }).then(function (response) {
                this.users = response.data.data;


            }.bind(this));
        },

        getCompanyinfo: function () {

            axios.get(this.$api_url + '/companyinfo', {
                params: {
                    page: 1,

                }
            }).then(function (response) {
                this.company_code = response.data.company_code;
                this.company_name = response.data.company_name;
                this.company_address = response.data.company_address;

                this.challanfdata.month = response.data.month;
                this.challanfdata.fiscal_year = response.data.year;
                var challan_ref = response.data.challan_ref;

                var yr = this.challanfdata.fiscal_year.split("-");
                var year = '';

                if (this.challanfdata.month == "January" || this.challanfdata.month == "February" || this.challanfdata.month == "March" || this.challanfdata.month == "April" || this.challanfdata.month == "May" || this.challanfdata.month == "June")
                    year = yr[1];
                else
                    year = yr[0];

                this.chalan_reference = "CH-" + challan_ref;
                this.challanfdata.challan_title = "Challan of " + this.company_name + ", " + this.challanfdata.month + " " + year;
                this.challanfdata.payee = this.company_name + "\n" + this.company_address;
                this.challanfdata.paying_for = "Employees of \n" + this.company_name + "\n" + this.company_address;

                if (parseInt(yr[1]) > 2023)
                    this.challanfdata.citation = "Tax deducted at source from salary under section 86 of the Income Tax Act 2023";
                else
                    this.challanfdata.citation = "Tax deducted at source from salary under section 50 of the Income tax Ordinance 1984";


            }.bind(this));
        },


        setemployee: function () {
            //alert(this.challanfdata.company_employee);
            var eployeelist = this.challanfdata.company_employee;
            var employeearray = eployeelist.split("^^");

            var arlength = employeearray.length;
            var counter = 0;
            var endofstack = arlength - 1;
            for (counter = 0; counter < arlength; counter++) {
                var empltxt = employeearray[counter];
                var empltxtarray = empltxt.split("=");

                this.challanemployees.push(empltxtarray[0]);
                this.employeenames.push(empltxtarray[2]);
                this.employeetds.push(empltxtarray[1]);
                this.employeeetins.push(empltxtarray[3]);
                this.employeeremainings.push(empltxtarray[4]);

            }

            this.updatestack();

            this.challansearch.name = "";
            this.current_employee_id = "";
            this.tds_field = "";
            this.tds_remaining = "";
            this.current_employee_etin = "";
            this.users = [];


        },

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },


        onImageChange(e) {
            console.log(e.target.files[0]);
            this.image = e.target.files[0];
        },

        showDraftChallan: function (draft_id) {
            this.draft_challan_id = draft_id;
            this.$bvModal.show('draft-modal');
            this.draftpass = '';
            this.incorrectpass = '';
        },

        draftChallan: function (draft_id) {

            let currentObj = this;
            if (this.draftpass != '') {

                this.draft_loading = 'load';

                let formData = new FormData();
                formData.append('challan_id', draft_id);
                formData.append('draft_pass', this.draftpass);

                axios.post(this.$api_url + '/challanmakedraft', formData)

                    .then(function (response) {
                        if (response.data.success == '1') {
                            currentObj.incorrectpass = '';
                            currentObj.$bvModal.hide('draft-modal');
                            currentObj.getchallans();
                        }
                        else {
                            currentObj.incorrectpass = "Incorrect Password";
                        }
                        currentObj.draft_loading = '';

                    })
                    .catch(function (error) {

                        //currentObj.output = error;

                    });

            }

            // this.getchallans();
        },


        challanStatusSubmit(e) {
            e.preventDefault();
            let currentObj = this;

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            let formData = new FormData();
            formData.append('image', this.image);

            for (let [key, value] of Object.entries(this.challanfdata)) {

                var nm = `${key}`;
                var fval = `${value}`;
                if (nm == 'challan_title') {
                    if (fval.indexOf(this.chalan_reference) < 0)
                        fval = this.chalan_reference + ": " + fval;

                }
                formData.append(nm, fval);

                //console.log(`${key}: ${value}`);
            }


            //this.new_challan_loading="Loading";
            axios.post(this.$api_url + '/challanstatusupdate', formData, config)

                .then(function (response) {
                    if (currentObj.employee_delete_flag != 'yes')
                        currentObj.modalsuccess = response.data.success;

                    currentObj.$bvModal.hide('challan_modal_confirm');

                    if (currentObj.employee_delete_flag != 'yes')
                        currentObj.$bvModal.hide('challan_modaledit');


                    currentObj.new_challan_loading = '';
                    currentObj.employee_delete_flag = '';
                    currentObj.getchallans();

                })

                .catch(function (error) {

                    currentObj.output = error;

                });

        },

        challanformSubmit(e) {

            e.preventDefault();
            if(!this.challanfdata.payment_type) {
                this.$bvToast.toast("Please select a payment method.", {
                    title: "Error",
                    variant: 'danger',
                    solid: true,
                });
                return;
            }

            let currentObj = this;

            const config = {

                headers: { 'content-type': 'multipart/form-data' }

            }


            let formData = new FormData();
            formData.append('image', this.image);
            formData.append('payrun_id', this.search_by_id.payrun_id);

            for (let [key, value] of Object.entries(this.challanfdata)) {

                var nm = `${key}`;
                var fval = `${value}`;
                if (nm == 'challan_title') {
                    if (fval.indexOf(this.chalan_reference) < 0)
                        fval = this.chalan_reference + ": " + fval;

                }
                formData.append(nm, fval);

                //console.log(`${key}: ${value}`);
            }


            //return 1;

            if (this.load_employees_tds) {

                //for
                var employee_tds_val = '';
                for (let [key, value] of Object.entries(this.employees_tds_data)) {

                    employee_tds_val = employee_tds_val + key + "$$" + this.toMoney(value) + "||";
                }
                formData.append('employee_tds_values', employee_tds_val);
                //console.log(JSON.stringify(this.employees_tds_data));

            }

            /*load_employees_tds : 0,
              employees_tds_total : 0,
              employees_tds_remaining : 0,
              employees_tds_data : [],*/


            //console.log(JSON.stringify(formData));
            /*for (var pair of formData.entries()) {
console.log(pair[0]+ ', ' + pair[1]);
}*/

            //return 1;

            this.new_challan_loading = "Loading";
            axios.post(this.$api_url + '/challanstorevue', formData, config)

                .then(function (response) {
                    if (currentObj.employee_delete_flag != 'yes')
                        currentObj.modalsuccess = response.data.success;

                    currentObj.$bvModal.hide('challan_modalnew');

                    if (currentObj.employee_delete_flag != 'yes')
                        currentObj.$bvModal.hide('challan_modaledit');


                    currentObj.new_challan_loading = '';
                    currentObj.employee_delete_flag = '';
                    currentObj.getchallans();

                })

                .catch(function (error) {

                    currentObj.output = error;

                });

        },

        ///////////////////////////////////////


        /*etds a chllan:1 Start*/
        getEmployees: function () {
            if (!this.checkNet()) return false;
            this.showoverlay = true;
            let currentObj = this;
            axios.get(this.$api_url + '/employee/list', {

            }).then(function (response) {

                this.showoverlay = false;
                if (response.data.error == 1)
                    this.notice = response.data.notice;
                else {
                    this.employees = response.data.employee_data;
                    this.company_options = response.data.options;
                    //this.company_options = this.company_options.filter(item => item.label !== 'status'); // etds a chllan:2 Rejwan: 03-03-2025

                    this.list_key = this.list_key + 1;

                }

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });
        },

        geteTDSLists: function () {
            this.show_challan_list = 0;
            this.getEmployees();
        },

        // etds a chllan:1 Start: Rejwan: 25-02-2025
        showChallanList: function () {
            this.showoverlay = true;
            this.show_challan_list = 1;
            setTimeout(() => {
                this.showoverlay = false;
            }, 300);
        },
        /*etds a chllan:1 End*/
        //Asfaq's Code

        // Handle button click to trigger tds templete file input
        tdsFileInput: function () {
            this.$refs.tdsFile.click();
        },

        // Handling the tds templete file input
        onTdsFileChange: function (event) {
            this.employees_tds_input_file = event.target.files[0]; // Get the file from the input

            if (this.employees_tds_input_file) {
                this.uploadFile();  // Proceed with the upload
            }
        },

        // Upload the challan data sheet to the backend and process the returned output
        uploadFile: function () {
            const formData = new FormData();
            formData.append('tdsFile', this.employees_tds_input_file);

            axios.post(this.$api_url + '/challantdsimportexcel', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(response => {
                    // 16 april 2025
                    if (response.data.status == 422) {
                        this.errors = response.data.errors;
                        return;
                    }
                    else if (response.data.status == 500) {
                        this.$bvToast.toast(response.data.message, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                        return;
                    }
                    //16 april 2025
                    else {
                        this.errors = [];
                        this.$bvToast.toast(response.data.message, {
                            title: 'Success!',
                            variant: 'success',
                            solid: true,
                            toaster: "toaster: b-toaster-top-right"
                        });

                        let tempTdsData = [];

                        this.employees_tds_actual_data = [];
                        this.employees_tds_remain_data = [];
                        this.employees_tds_data = [];
                        this.employees_tds = [];

                        // Process the data
                        response.data.data.forEach((val) => {

                            if (!isNaN(val[0]) && Number(val[0]) % 1 === 0) {
                                tempTdsData.push({
                                    employee_id: val[0],
                                    employee_name: val[2],
                                    tds: val[10]
                                });

                                this.employees_tds_actual_data[val[0]] = val[10];
                                this.employees_tds_remain_data[val[0]] = val[9];
                                this.employees_tds_data[val[0]] = val[8];
                            }
                        });

                        // if need to change the year and month of the dropdown
                        // this.search.fiscal_year = response.data.data[0][7]
                        // this.search.month = response.data.data[0][6].split(' ')[0]
                        // this.challanfdata.month = response.data.data[0][6].split(' ')[0]
                        // this.challanfdata.fiscal_year = response.data.data[0][7]


                        this.employees_tds = tempTdsData;

                        this.triggerTdsTotalChange();
                    }
                    //16 april 2025

                })
                .catch((error) => {
                    console.error("Upload error:", error);
                    this.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                });

        },



        //15 April 2025 challan info export import in edit mode
        // Handle button click to trigger tds templete file input
        employeeTdsFileInput: function () {
            this.$refs.employeeTdsFile.click();
        },

        // Handling the tds templete file input
        onEmployeeTdsFileChange: function (event) {
            this.employees_tds_input_file = event.target.files[0]; // Get the file from the input

            if (this.employees_tds_input_file) {
                this.uploadEmployeeFileEditMode();  // Proceed with the upload
            }
        },

        // Upload the challan data sheet to the backend and process the returned output
        uploadEmployeeFileEditMode: function () {
            const formData = new FormData();
            formData.append('tdsFile', this.employees_tds_input_file);

            axios.post(this.$api_url + '/challantdsimportexcel', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(response => {
                    // 16 april 2025
                    if (response.data.status == 422) {
                        this.errors = response.data.errors;
                        return;
                    }
                    else if (response.data.status == 500) {
                        this.$bvToast.toast(response.data.message, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                        return;
                    }
                    //16 april 2025
                    else {
                        this.$bvToast.toast(response.data.message, {
                            title: 'Success!',
                            variant: 'success',
                            solid: true,
                            toaster: "toaster: b-toaster-top-right"
                        });
                        if (response.data.code === 500) {
                            this.$bvToast.toast(response.data.message, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                            return;
                        }

                        this.challanemployees = [];
                        this.employeenames = [];
                        this.employeetds = [];
                        this.employeeremainings = [];
                        this.employeeetins = [];

                        this.updatestack();
                        response.data.data.forEach((val) => {
                            this.challanemployees.push(val[0]);
                            this.employeenames.push(val[2]);
                            this.employeetds.push(parseFloat(val[8].toString().replaceAll(',', '')));
                            this.employeeremainings.push(parseFloat(val[9].toString().replaceAll(',', '')));
                        });


                        this.updatestack();
                    }

                })
                .catch((error) => {
                    console.error("Upload error:", error);
                    this.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                });

        },

        //15 April 2025 challan info export import in edit mode end

        // Exporting the challan list as excel format
        exportTDSList: function () {
            this.downloading = true
            let tdsList = [];
            //console.log(JSON.stringify(this.employees_tds));
            // Update challan list
            for (const [index, emp] of this.employees_tds.entries()) {
                tdsList.push({
                    employee_name: emp.employee_name,
                    employee_id: emp.employee_id,
                    month: this.search.month,
                    challan_year: this.search.fiscal_year,
                    tds_amount: parseFloat(this.employees_tds_data[emp.employee_id].toString().replaceAll(',', '')),
                    tds_due: parseFloat(this.employees_tds_remain_data[emp.employee_id].toString().replaceAll(',', '')),
                });
            }

            let alltdsList = [];

            // all challan list
            for (const [index, emp] of this.all_employees_tds.entries()) {
                alltdsList.push({
                    employee_name: emp.employee_name,
                    employee_id: emp.employee_id,
                    month: this.search.month,
                    challan_year: this.search.fiscal_year,
                    tds_amount: parseFloat(emp.tds_amount.toString().replaceAll(',', '')),
                    tds_due: parseFloat(emp.tds_due.toString().replaceAll(',', '')),
                });
            }

            const formData = new FormData();
            formData.append('tdsList', JSON.stringify({
                updateTds: tdsList,
                allTds: alltdsList
            }));


            const config = {
                headers: { 'Content-Type': 'multipart/form-data' },
                responseType: 'blob'
            };

            axios.post(this.$api_url + '/challantdsexcel', formData, config)
                .then((response) => {
                    this.$bvToast.toast(response.data.message, { title: 'Success!', variant: 'success', solid: true, toaster: "toaster: b-toaster-top-right" });

                    const blob = new Blob([response.data], {
                        type: 'application/vnd.ms-excel'
                    });

                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', 'Challan Download Template.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.downloading = false
                })
                .catch((error) => {
                    console.error("Download error:", error);
                    this.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                });

        },
        // 15 april 2025 export employee tds list from edit function
        exportEmployeeList: async function () {
            this.downloading = true
            //   23 april 2025
            let employees_tds = [];
            let all_employees_tds = [];
            let employees_tds_data = [];
            let employees_tds_remain_data = [];
            let employees_tds_actual_data = [];
            let employees_tds_total = 0;
            if (this.challanfdata.fiscal_year && this.challanfdata.month) {
                await axios.get(this.$api_url + '/challanemployees', {
                    params: {
                        fiscal_year: this.challanfdata.fiscal_year,
                        month: this.challanfdata.month
                    }
                })
                    .then(function (response) {

                        this.tds_loading = false;
                        employees_tds = response.data.data;
                        this.load_employees_tds = 1;
                        for (var i = 0; i < employees_tds.length; ++i) {
                            employees_tds_total = employees_tds_total + parseFloat(employees_tds[i]['tds']);

                            if (this.decimal_setting == 'yes') {
                                employees_tds_data[employees_tds[i]['employee_id']] = this.formatMoney(parseFloat(employees_tds[i]['tds']).toFixed(2));
                                if (employees_tds_data[employees_tds[i]['employee_id']].indexOf(".") < 0)
                                    employees_tds_data[employees_tds[i]['employee_id']] = employees_tds_data[employees_tds[i]['employee_id']] + '.00';
                            } else {
                                employees_tds_data[employees_tds[i]['employee_id']] = this.formatMoneyRound(Math.round(employees_tds[i]['tds']));
                            }
                            //this.employees_tds_data[this.employees_tds[i]['employee_id']] = this.employees_tds[i]['tds'];
                            if (this.decimal_setting == 'yes')
                                employees_tds_remain_data[employees_tds[i]['employee_id']] = 0 + '.00';
                            else
                                employees_tds_remain_data[employees_tds[i]['employee_id']] = 0;
                            employees_tds_actual_data[employees_tds[i]['employee_id']] = employees_tds[i]['tds']

                        }


                        // 13 april 2025
                        // Reseve all employees data
                        all_employees_tds = [];
                        for (const emp of employees_tds) {
                            all_employees_tds.push({
                                employee_id: emp.employee_id,
                                employee_name: emp.employee_name,
                                tds_amount: employees_tds_data[emp.employee_id],
                                tds_due: employees_tds_remain_data[emp.employee_id],
                            });
                        }
                        //   23 april 2025
                        let tdsList = [];
                        // Update challan list
                        this.all_employees_tds = [];
                        let employeeList = this.challanfdata.company_employee;
                        let employeeArray = employeeList.split("^^");
                        for (let counter = 0; counter < employeeArray.length; counter++) {
                            tdsList.push({
                                employee_name: this.employeenames[counter],
                                employee_id: this.challanemployees[counter],
                                month: this.challanfdata.month,
                                challan_year: this.challanfdata.fiscal_year,
                                tds_amount: parseFloat(this.employeetds[counter].toString().replaceAll(',', '')),
                                tds_due: parseFloat(this.employeeremainings[counter].toString().replaceAll(',', '')),
                            });
                        }


                        let alltdsList = [];

                        // // console.log('All Employees edit mode ==> '+ JSON.stringify(this.tdsAllEmployeesDataList));
                        // all challan list
                        for (const [index, emp] of this.tdsAllEmployeesDataList.entries()) {
                            alltdsList.push({
                                employee_name: emp.employee_name,
                                employee_id: emp.employee_id,
                                month: this.challanfdata.month,
                                challan_year: this.challanfdata.fiscal_year,
                                tds_amount: parseFloat(emp.tds_amount.toString().replaceAll(',', '')),
                                tds_due: parseFloat(emp.tds_due.toString().replaceAll(',', '')),
                            });
                        }

                        // all challan list merging rest data // 27 april 2025
                        for (const [index, emp] of all_employees_tds.entries()) {
                            alltdsList.push({
                                employee_name: emp.employee_name,
                                employee_id: emp.employee_id,
                                month: this.challanfdata.month,
                                challan_year: this.challanfdata.fiscal_year,
                                tds_amount: parseFloat(emp.tds_amount.toString().replaceAll(',', '')),
                                tds_due: parseFloat(emp.tds_due.toString().replaceAll(',', '')),
                            });
                        }

                        const formData = new FormData();
                        formData.append('tdsList', JSON.stringify({
                            updateTds: tdsList,
                            allTds: alltdsList
                        }));


                        const config = {
                            headers: { 'Content-Type': 'multipart/form-data' },
                            responseType: 'blob'
                        };

                        axios.post(this.$api_url + '/challantdsexcel', formData, config)
                            .then((response) => {
                                // // console.log("File download response:", response);
                                this.$bvToast.toast(response.data.message, { title: 'Success!', variant: 'success', solid: true, toaster: "toaster: b-toaster-top-right" });

                                const blob = new Blob([response.data], {
                                    type: 'application/vnd.ms-excel'
                                });

                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.setAttribute('download', 'Challan Download Template.xlsx');
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                                this.downloading = false
                            })
                            .catch((error) => {
                                console.error("Download error:", error);
                                this.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                            });


                    }.bind(this));
            }


        },
        // 15 april 2025 export employee tds list from edit function
        //Asfaq's Code End
        // 15 april 2025 export employee tds list from edit function
    },
    created: function () {
        this.getchallans();
        //this.getpayruns();
        this.getpayrunsfiscalyear();
        this.seturlSearch();
        this.getBankList();
        this.get_decimal_settings();
        /*etds a chllan:1 Start*/
        this.getDepartments();
        this.getJobpositions();
        /*etds a chllan:1 End*/

    },
    computed:
    {
        filteredData() {

            this.backdoor;
            let filtered_list = this.challans;
            if (this.this_search_fiscal) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.this_search_fiscal.toLowerCase()) > -1; }) });
            }
            if (this.this_search_month) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.this_search_month.toLowerCase()) > -1; }) });
            }
            if (this.this_search_status) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.this_search_status.toLowerCase()) > -1; }) });
            }
            if (this.this_search_title) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.this_search_title.toLowerCase()) > -1; }) });
            }

            if (this.search_bar) {

                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search_bar.toLowerCase()) > -1; }) });

            }

            let sortKey = this.sortKey;


            let order = this.sortOrders[sortKey] || 1;


            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {

                    let index = this.getIndex(this.columns, 'challan_ref', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    let aa = (a === b ? 0 : a > b ? 1 : -1) * order;
                    return (a === b ? 0 : a > b ? 1 : -1) * order;

                }
                );
            }

            this.people = filtered_list.length;


            return filtered_list;
        },
        paginatedData() {
            this.backdoor;
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },


    }
}
</script>
<style>
button.disabled {
    cursor: default;
}

.tb-border {
    border: 1px solid #808080;
    border-radius: 0.25rem !important;
    border-collapse: separate;
}

.tb-border td {
    padding: 2px !important;
}

.year-wrapper {
    margin-right: 10px !important;
    max-width: 18%;
}

.trz_loader {
    text-align: center;
}

/* .checkbox-col {
  width: 40px;
  min-width: 40px;
  text-align: center;
  vertical-align: middle;
  padding-left: 12px !important;
  padding-right: 8px !important;
} */
</style>
